webpackJsonp([35783957827783],{

/***/ 141:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.hoistNonReactStatics = factory());
	}(this, (function () {
	    'use strict';
	    
	    var REACT_STATICS = {
	        childContextTypes: true,
	        contextTypes: true,
	        defaultProps: true,
	        displayName: true,
	        getDefaultProps: true,
	        getDerivedStateFromProps: true,
	        mixins: true,
	        propTypes: true,
	        type: true
	    };
	    
	    var KNOWN_STATICS = {
	        name: true,
	        length: true,
	        prototype: true,
	        caller: true,
	        callee: true,
	        arguments: true,
	        arity: true
	    };
	    
	    var defineProperty = Object.defineProperty;
	    var getOwnPropertyNames = Object.getOwnPropertyNames;
	    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	    var getPrototypeOf = Object.getPrototypeOf;
	    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	    
	    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	            
	            if (objectPrototype) {
	                var inheritedComponent = getPrototypeOf(sourceComponent);
	                if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	                }
	            }
	            
	            var keys = getOwnPropertyNames(sourceComponent);
	            
	            if (getOwnPropertySymbols) {
	                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	            }
	            
	            for (var i = 0; i < keys.length; ++i) {
	                var key = keys[i];
	                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                    try { // Avoid failures from read-only properties
	                        defineProperty(targetComponent, key, descriptor);
	                    } catch (e) {}
	                }
	            }
	            
	            return targetComponent;
	        }
	        
	        return targetComponent;
	    };
	})));


/***/ }),

/***/ 25:
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),

/***/ 96:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(25)))

/***/ }),

/***/ 97:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(window, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(96);
	// On some exotic environments, it's not clear which object `setimmeidate` was
	// able to install onto.  Search each possibility in the same order as the
	// `setimmediate` library.
	exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
	                       (typeof global !== "undefined" && global.setImmediate) ||
	                       (this && this.setImmediate);
	exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
	                         (typeof global !== "undefined" && global.clearImmediate) ||
	                         (this && this.clearImmediate);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 399:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/badgesMap.ca760a76.svg";

/***/ }),

/***/ 400:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/hero1.00d57a63.jpg";

/***/ }),

/***/ 401:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/hero2.6e0da285.jpg";

/***/ }),

/***/ 402:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/hero3.5ba8e972.jpg";

/***/ }),

/***/ 403:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/introductionSlider1.c949edd8.jpg";

/***/ }),

/***/ 404:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/introductionSlider2.ca6c99f3.jpg";

/***/ }),

/***/ 405:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/introductionSlider3.0df87a75.jpg";

/***/ }),

/***/ 406:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/introductionSlider4.499d7c75.jpg";

/***/ }),

/***/ 407:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/introductionSlider5.47a647a3.jpg";

/***/ }),

/***/ 408:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/introductionSlider6.7c489f9c.jpg";

/***/ }),

/***/ 409:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/reviewsImage.a064063f.jpg";

/***/ }),

/***/ 412:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/logo.19ecf48b.svg";

/***/ }),

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(36);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _ButtonModule = __webpack_require__(86);
	
	var _ButtonModule2 = _interopRequireDefault(_ButtonModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Button = function Button(props) {
	  var classes = [_ButtonModule2.default.button, _ButtonModule2.default[props.size], _ButtonModule2.default[props.color], props.text ? _ButtonModule2.default.text : null, props.inline ? _ButtonModule2.default.inline : null, props.disabled ? _ButtonModule2.default.disabled : null, props.loading ? _ButtonModule2.default.loading : null].join(' ');
	
	  if (props.render) {
	    switch (props.type) {
	      case 'anchor':
	        return _react2.default.createElement(
	          'a',
	          {
	            className: classes,
	            href: props.to,
	            onClick: props.onClick,
	            rel: props.target === '_blank' ? 'nofollow noopener' : null,
	            target: props.target
	          },
	          props.loading && _react2.default.createElement('div', { className: _ButtonModule2.default.loader }),
	          props.children
	        );
	
	      case 'link':
	        return _react2.default.createElement(
	          _gatsbyLink2.default,
	          {
	            className: classes,
	            onClick: props.onClick,
	            to: props.to
	          },
	          props.loading && _react2.default.createElement('div', { className: _ButtonModule2.default.loader }),
	          props.children
	        );
	
	      default:
	        return _react2.default.createElement(
	          'button',
	          {
	            className: classes,
	            'data-role': props['data-role'],
	            disabled: props.disabled,
	            onClick: props.onClick,
	            type: props.type
	          },
	          props.loading && _react2.default.createElement('div', { className: _ButtonModule2.default.loader }),
	          props.children
	        );
	    }
	  }
	
	  return null;
	};
	
	Button.propTypes = {
	  color: _propTypes2.default.string,
	  disabled: _propTypes2.default.bool,
	  inline: _propTypes2.default.bool,
	  loading: _propTypes2.default.bool,
	  onClick: _propTypes2.default.func,
	  render: _propTypes2.default.bool,
	  role: _propTypes2.default.string,
	  size: _propTypes2.default.string,
	  target: _propTypes2.default.string,
	  text: _propTypes2.default.bool,
	  to: _propTypes2.default.string,
	  type: _propTypes2.default.string
	};
	
	Button.defaultProps = {
	  color: 'default',
	  disabled: false,
	  loading: false,
	  render: true,
	  to: '/',
	  type: 'button'
	};
	
	exports.default = Button;
	module.exports = exports['default'];

/***/ }),

/***/ 86:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"loader":"src-components-Button----Button-module---loader---2Z10x","before":"src-components-Button----Button-module---before---qmENX","after":"src-components-Button----Button-module---after---Plk0h","t-body":"src-components-Button----Button-module---t-body---27Yc1","t-small":"src-components-Button----Button-module---t-small---3GB4w","t-heading-xs":"src-components-Button----Button-module---t-heading-xs---2oggE","t-heading-s":"src-components-Button----Button-module---t-heading-s---3ZTU1","t-heading-m":"src-components-Button----Button-module---t-heading-m---1LD7a","t-heading-l":"src-components-Button----Button-module---t-heading-l---2hKwA","t-heading-xl":"src-components-Button----Button-module---t-heading-xl---1w63S","t-anchors":"src-components-Button----Button-module---t-anchors---hriac","t-buttons":"src-components-Button----Button-module---t-buttons---aovZh","button":"src-components-Button----Button-module---button---3zCJK","t-buttons-large":"src-components-Button----Button-module---t-buttons-large---20U-L","large":"src-components-Button----Button-module---large---2FBVs","t-formLabel":"src-components-Button----Button-module---t-formLabel---2PGiX","t-formHelper":"src-components-Button----Button-module---t-formHelper---330nk","t-formInput":"src-components-Button----Button-module---t-formInput---hmcW1","t-tableHeading":"src-components-Button----Button-module---t-tableHeading---2IGfJ","t-tableBody":"src-components-Button----Button-module---t-tableBody---mez5D","t-opaque":"src-components-Button----Button-module---t-opaque---3C55D","t-bold":"src-components-Button----Button-module---t-bold---1Q25R","t-italic":"src-components-Button----Button-module---t-italic---A7lQz","default":"src-components-Button----Button-module---default---2qZOn","text":"src-components-Button----Button-module---text---1P8Ig","confirm":"src-components-Button----Button-module---confirm---3hxrC","cancel":"src-components-Button----Button-module---cancel---2cAPw","inline":"src-components-Button----Button-module---inline---2j4bF","small":"src-components-Button----Button-module---small---KnqJd","disabled":"src-components-Button----Button-module---disabled---2t4w_","loading":"src-components-Button----Button-module---loading---olGuc","slideInTop":"src-components-Button----Button-module---slideInTop---3l0IE","slideInTopMild":"src-components-Button----Button-module---slideInTopMild---d6Q95","slideInBottom":"src-components-Button----Button-module---slideInBottom---1yjcf","slideInBottomMild":"src-components-Button----Button-module---slideInBottomMild---1ooY3","slideOutTop":"src-components-Button----Button-module---slideOutTop---2QZjY","slideOutTopMild":"src-components-Button----Button-module---slideOutTopMild---2sNx1","slideOutBottom":"src-components-Button----Button-module---slideOutBottom---3x-ig","slideOutBottomMild":"src-components-Button----Button-module---slideOutBottomMild---1-Hoa","shake-horizontal":"src-components-Button----Button-module---shake-horizontal---1ZVqj"};

/***/ }),

/***/ 26:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Button = __webpack_require__(53);
	
	var _Button2 = _interopRequireDefault(_Button);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _Button2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _paths = __webpack_require__(55);
	
	var _paths2 = _interopRequireDefault(_paths);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Icon = function Icon(props) {
	  var styles = _extends({
	    fill: 'currentColor',
	    lineHeight: 'inherit',
	    stroke: 'currentColor',
	    strokeWidth: 0,
	    verticalAlign: props.valign
	  }, props.styles);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      height: props.size,
	      width: props.size,
	      style: styles,
	      viewBox: '0 0 1024 1024'
	    }, props),
	    _react2.default.createElement('path', { d: _paths2.default[props.type] })
	  );
	};
	
	Icon.propTypes = {
	  size: _propTypes2.default.number,
	  styles: _propTypes2.default.object,
	  type: _propTypes2.default.string.isRequired,
	  valign: _propTypes2.default.string
	};
	
	Icon.defaultProps = {
	  size: 16,
	  valign: 'middle'
	};
	
	exports.default = Icon;
	module.exports = exports['default'];

/***/ }),

/***/ 27:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Icon = __webpack_require__(54);
	
	var _Icon2 = _interopRequireDefault(_Icon);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _Icon2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 55:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var icons = {
	  bed: 'M1022.3 690c1.6-4.2 2.1-8.9 0.7-13.6l-84.4-274.1V149.3c0-58.8-47.8-106.7-106.7-106.7H192c-58.8 0-106.7 47.9-106.7 106.7v252.9L1 676.4c-1.4 4.7-0.9 9.3 0.7 13.6 -1 4.5-1.7 9.2-1.7 14v170.7V960c0 11.8 9.6 21.3 21.3 21.3h85.3c11.8 0 21.3-9.6 21.3-21.3v-64h768v64c0 11.8 9.6 21.3 21.3 21.3h85.3c11.8 0 21.3-9.6 21.3-21.3v-85.3V704C1024 699.1 1023.4 694.5 1022.3 690zM128 149.3c0-35.3 28.7-64 64-64h640c35.3 0 64 28.7 64 64V384h-58l-19.9-79.5C811 275.9 785.4 256 756 256H618.7c-35.3 0-64 28.7-64 64v64h-85.3v-64c0-35.3-28.7-64-64-64H268c-29.4 0-55 20-62.1 48.5L186 384h-58V149.3zM794.2 418.5c-4.1 5.2-10.2 8.2-16.9 8.2H618.7c-11.7 0-21.3-9.6-21.3-21.3V320c0-11.8 9.6-21.3 21.3-21.3h137.4c9.8 0 18.3 6.6 20.7 16.1l21.3 85.3C799.7 406.6 798.3 413.2 794.2 418.5zM426.7 320v85.1c0 0.1 0 0.1 0 0.2 0 0 0 0.1 0 0.1 0 11.7-9.6 21.2-21.3 21.2H246.7c-6.7 0-12.8-3-16.9-8.2 -4.1-5.2-5.5-11.9-3.9-18.3l21.3-85.3c2.4-9.5 10.9-16.1 20.7-16.1h137.3C417.1 298.7 426.7 308.2 426.7 320zM122.4 426.7h64.2c2.3 6.4 5.2 12.5 9.5 18.1 12.3 15.6 30.7 24.6 50.5 24.6h158.7c27.8 0 51.2-17.9 60.1-42.7h93.2c8.8 24.8 32.3 42.7 60.1 42.7h158.7c19.8 0 38.2-9 50.5-24.6 4.3-5.5 7.3-11.7 9.5-18.1h64.3l65.9 214.1c-2.5-0.3-4.9-0.8-7.5-0.8H64c-2.6 0-5 0.5-7.4 0.8L122.4 426.7zM85.3 938.7H42.7V896h42.7L85.3 938.7 85.3 938.7zM981.3 938.7h-42.7V896h42.7V938.7zM981.3 853.3H42.7V704c0-11.8 9.6-21.3 21.3-21.3h896c11.7 0 21.3 9.6 21.3 21.3V853.3z',
	  bedroom: 'M648.5 650.3V494.9c0-28.2-23-51.2-51.2-51.2H119.5c-28.2 0-51.2 23-51.2 51.2v155.3C29.4 658.2 0 692.7 0 733.9v102.4 170.7c0 9.4 7.6 17.1 17.1 17.1h68.3c9.4 0 17.1-7.6 17.1-17.1v-51.2h512v51.2c0 9.4 7.6 17.1 17.1 17.1h68.3c9.4 0 17.1-7.6 17.1-17.1V836.3 733.9C716.8 692.7 687.4 658.2 648.5 650.3zM102.4 494.9c0-9.4 7.7-17.1 17.1-17.1h477.9c9.4 0 17.1 7.7 17.1 17.1v153.6h-34.1v-68.3c0-28.2-23-51.2-51.2-51.2H426.7c-28.2 0-51.2 23-51.2 51.2v68.3h-34.1v-68.3c0-28.2-23-51.2-51.2-51.2H187.7c-28.2 0-51.2 23-51.2 51.2v68.3h-34.1V494.9zM546.1 580.3v68.3H409.6v-68.3c0-9.4 7.7-17.1 17.1-17.1h102.4C538.5 563.2 546.1 570.9 546.1 580.3zM307.2 580.3v68.3H170.7v-68.3c0-9.4 7.7-17.1 17.1-17.1h102.4C299.5 563.2 307.2 570.9 307.2 580.3zM682.7 989.9h-34.1v-51.2c0-9.4-7.6-17.1-17.1-17.1H85.3c-9.4 0-17.1 7.6-17.1 17.1v51.2H34.1V853.3h648.5V989.9zM682.7 819.2H34.1v-85.3c0-28.2 23-51.2 51.2-51.2h68.3 170.7 68.3 170.7 68.3c28.2 0 51.2 23 51.2 51.2V819.2zM1006.9 648.5H768c-9.4 0-17.1 7.6-17.1 17.1v136.5 119.5h34.1V819.2h204.8v102.4h34.1V802.1 665.6C1024 656.2 1016.4 648.5 1006.9 648.5zM989.9 785.1H785.1V682.7h204.8V785.1zM853.3 716.8h68.3v34.1h-68.3V716.8zM971.9 506.6l-34.1-102.4c-2.3-7-8.8-11.7-16.2-11.7h-68.3c-7.4 0-13.9 4.7-16.2 11.7L803 506.6c-1.7 5.2-0.9 10.9 2.4 15.4 3.2 4.5 8.4 7.1 13.8 7.1h51.2v51.2h-34.1v34.1h102.4v-34.1h-34.1v-51.2h51.2c5.5 0 10.6-2.6 13.8-7.1C972.8 517.5 973.7 511.8 971.9 506.6zM842.9 494.9l22.8-68.3h43.7l22.7 68.3H842.9zM1013.9 223.4L519 1.5c-4.5-2-9.5-2-14 0L10.1 223.4C3.9 226.1 0 232.2 0 238.9v204.8h34.1V250L512 35.8 989.9 250v193.7h34.1V238.9C1024 232.2 1020.1 226.1 1013.9 223.4zM629.8 236.1l-33.7 5.7c0.8 4.7 1.2 9.4 1.2 14.2 0 47.1-38.3 85.3-85.3 85.3s-85.3-38.3-85.3-85.3 38.3-85.3 85.3-85.3c9.8 0 19.4 1.6 28.5 4.9l11.4-32.2c-12.8-4.5-26.2-6.8-39.8-6.8 -65.9 0-119.5 53.6-119.5 119.5S446.1 375.5 512 375.5 631.5 321.9 631.5 256C631.5 249.3 630.9 242.6 629.8 236.1zM619.4 141.5L512 248.9l-22.1-22.1L465.8 251l34.1 34.1c3.3 3.3 7.7 5 12.1 5 4.4 0 8.7-1.7 12.1-5l119.5-119.5L619.4 141.5z',
	  bike: 'M810.7 416c-19.5 0-38.3 2.6-56.3 7.5l-54.9-142.9 19.9-20.4c8.1-8.4 8-21.7-0.2-30l-42.7-42.6c-4-4-9.4-6.3-15.1-6.3H554.7c-11.8 0-21.3 9.6-21.3 21.3 0 11.8 9.6 21.3 21.3 21.3h97.8l21.6 21.5 -14.8 15.1c-5.9 6.1-7.4 14.9-4.7 22.4 0 0 0 0.1 0 0.2l19.6 51L384 370.5v-39.8h64c11.8 0 21.3-9.6 21.3-21.3S459.8 288 448 288H320c-11.8 0-21.3 9.5-21.3 21.3s9.5 21.3 21.3 21.3h21.3v58.2L311.5 440c-29.4-15.3-62.8-24-98.2-24C95.7 416 0 511.7 0 629.3 0 747 95.7 842.7 213.3 842.7c103 0 189.2-73.4 209-170.7h29.3c8.8 24.8 32.5 42.7 60.3 42.7 35.3 0 64-28.7 64-64 0-14.8-5-28.4-13.4-39.2l136.7-212.6 15.3 40c-69.5 35.2-117.2 107.3-117.2 190.4 0 117.7 95.7 213.4 213.3 213.4S1024 747 1024 629.3C1024 511.7 928.3 416 810.7 416zM213.3 800c-94.1 0-170.7-76.6-170.7-170.7 0-94.1 76.6-170.6 170.7-170.6 27.6 0 53.6 6.6 76.7 18.2l-95.1 163c-5.9 10.2-2.5 23.2 7.7 29.2 3.4 1.9 7.1 2.9 10.7 2.9 0 0 0.1 0 0.1 0h165.2C359.6 745.6 292.7 800 213.3 800zM250.5 629.3l75-128.5c35.8 31.3 58.5 77.3 58.5 128.5H250.5zM451.7 629.3h-25c0-66.9-31-126.8-79.4-165.9l15.4-26.4 100.5 172.3C458.2 615.2 454.3 621.9 451.7 629.3zM512 672c-11.8 0-21.3-9.6-21.3-21.3 0-11.8 9.6-21.4 21.3-21.4 11.8 0 21.3 9.6 21.3 21.4C533.3 662.4 523.8 672 512 672zM526.7 588.4c-4.7-1.1-9.6-1.7-14.7-1.7 -4.1 0-8.1 0.4-12 1.1l-102.7-176 264-33L526.7 588.4zM810.7 800C716.6 800 640 723.4 640 629.3c0-64.9 36.5-121.5 90-150.3l60.8 158c3.3 8.4 11.3 13.7 19.9 13.7 2.5 0 5.1-0.5 7.7-1.4 11-4.3 16.5-16.6 12.3-27.6l-60.8-158.1c13.1-3.2 26.8-5 40.9-5 94.1 0 170.7 76.6 170.7 170.6C981.3 723.4 904.8 800 810.7 800z',
	  boot: 'M1019 696.2l-68.3-68.3c-2.6-2.6-6-4.3-9.6-4.8l-116-16.6 -284-172.9 -98.2-310.8c-1.4-4.4-4.4-8-8.5-10.1 -4-2.1-8.8-2.4-13.2-1l-55.7 18.6c-34.9 11.6-58.4 44.2-58.4 80.9v2h-85.3c-2.3 0-4.5 0.4-6.6 1.3l-112.9 47v-14.2c0-28.2-23-51.2-51.2-51.2S0 219.2 0 247.5v68.3h0.2c0 1.4-0.1 2.7 0.3 4.1 32.8 131.3 32.8 270 0 401.3 -0.3 1.3-0.5 2.7-0.5 4.1v102.4c0 47.1 38.3 85.3 85.3 85.3h221.9c5.5 0 10.7-2.7 13.9-7.2l36-50.5 92 21.2 13.5 26.9c2.9 5.8 8.8 9.4 15.3 9.4h190.9c124.1 0 244.4-36.4 347.7-105.3 4.7-3.2 7.6-8.5 7.6-14.2v-85.3C1024 703.7 1022.2 699.4 1019 696.2zM436.8 216.6l60 190.1 -58-35.3 -29.2-43.8v-102L436.8 216.6zM341.3 211.3c0-22.1 14.1-41.6 35-48.6l39.3-13.1 10.9 34.4 -39.3 13.1c-7 2.3-11.7 8.8-11.7 16.2v63.1l-34.1-51.2V211.3zM307.2 349.9V247.5h7.9l97.3 146c1.4 2.1 3.2 3.8 5.3 5.1l34.5 21 -54.8 54.8 24.1 24.1 60.6-60.6 30.1 18.3 0.4 1.2 1.1-0.3 23.3 14.2 -54.3 54.3 24.1 24.1 60.2-60.2 54.9 33.4 -53.8 53.8 24.1 24.1 59.7-59.7 54.9 33.4 -53.4 53.4 24.1 24.1 59.3-59.3 54.9 33.4 -52.9 52.9 24.1 24.1 62.2-62.2 105.4 15.1 44.7 44.7L750 775.9l-302.6-67.2c-2.1-0.5-4.4-0.5-6.5-0.2l-83.5 13.9c-6.7-109.8-68.1-204.8-157.5-258.2l102.3-102.3C305.4 358.7 307.2 354.4 307.2 349.9zM56.3 453.4c142.3 10.8 256 124.6 266.9 266.9l-114.2-28.6c-3.4-0.9-7.2-0.6-10.5 0.7l-79.5 31.8 -78.5-26.2C57.4 617.7 62.6 535.2 56.3 453.4zM225.3 247.5h47.8v95.3L168.3 447.5c-35.5-16.2-74.3-26.1-115.2-28.5 -3.7-31.3-8.9-62.4-16.1-93.2L225.3 247.5zM34.1 247.5c0-9.4 7.6-17.1 17.1-17.1s17.1 7.7 17.1 17.1v28.5l-34.1 14.2V247.5zM989.9 784.4c-11.2 7.2-22.6 13.9-34.1 20.3v-11.1h-34.1v28.5c-11.2 5.3-22.6 10.2-34.1 14.7v-9.1h-34.1v21.4c-11.3 3.7-22.6 7.1-34.1 10.1v-14.4h-34.1v22.4c-11.3 2.3-22.7 4.4-34.1 6v-11.3h-34.1v15c-11.3 0.9-22.7 1.3-34.1 1.6v-16.6h-34.1v17.1h-34.1v-17.1h-34.1v17.1h-34.1v-17.1H512v17.1h-23.6l-12.4-24.7c-2.3-4.6-6.5-7.9-11.4-9l-110.9-25.6c-6.7-1.5-13.7 1.1-17.7 6.7l-37.6 52.6h-8.3v-34.1H256v34.1h-34.1v-34.1h-34.1v34.1h-34.1v-34.1h-34.1v34.1H85.3v-34.1H51.2v20.8c-10.4-9.4-17.1-22.8-17.1-37.9v-95.8l79.9 26.6c3.8 1.3 8 1.1 11.7-0.3l80.2-32.1L337.2 759c2.2 0.6 4.6 0.7 6.9 0.3l99.1-16.5 304 67.5c1.2 0.3 2.4 0.4 3.7 0.4 1.8 0 3.7-0.3 5.4-0.9l233.5-77.8V784.4z',
	  briefcase: 'M1004.6 187.6c-12.9-13.2-28.9-20-47.7-20H703.2V83.8c0-17.2-13.3-31.1-30.5-31.1h-3.3H666 358h-3.3 -3.3c-17.2 0-31.1 13.9-31.1 31.1v83.8H67.2c-18.9 0-34.8 6.8-47.7 20C6.8 200.5 0 216.5 0 234.8v669.3c0 18.3 6.5 34.5 19.4 47.7 12.6 12.9 28.9 19.4 47.7 19.4h889.7c18.9 0 35.1-6.5 47.7-19.4 12.9-13.2 19.4-29.4 19.4-47.7V234.8C1024 216.5 1017.2 200.5 1004.6 187.6zM381.8 114.3h260.3v53.3H381.8V114.3zM218.1 909.7h-151c-2.8 0-6.1-3.3-6.1-5.6V234.8c0-3.9 2.2-5.6 6.1-5.6h151V909.7zM744.3 909.7H280.8V229.2h463.4V909.7zM962.4 904.1c0 3.9-1.7 5.6-5.6 5.6h-151V229.2h151c3.9 0 5.6 1.7 5.6 5.6V904.1z',
	  calendar: 'M938.7 136.5h-17.1V51.2c0-28.2-23-51.2-51.2-51.2h-34.1c-28.2 0-51.2 23-51.2 51.2v85.3H238.9V51.2C238.9 23 216 0 187.7 0h-34.1c-28.2 0-51.2 23-51.2 51.2v85.3H85.3C38.3 136.5 0 174.8 0 221.9v716.8c0 47.1 38.3 85.3 85.3 85.3h853.3c47.1 0 85.3-38.3 85.3-85.3V221.9C1024 174.8 985.7 136.5 938.7 136.5zM819.2 153.6V51.2c0-9.4 7.6-17.1 17.1-17.1h34.1c9.4 0 17.1 7.6 17.1 17.1v102.4 68.3c0 9.4-7.6 17.1-17.1 17.1h-34.1c-9.4 0-17.1-7.6-17.1-17.1V153.6zM136.5 153.6V51.2c0-9.4 7.6-17.1 17.1-17.1h34.1c9.4 0 17.1 7.6 17.1 17.1v102.4 68.3c0 9.4-7.6 17.1-17.1 17.1h-34.1c-9.4 0-17.1-7.6-17.1-17.1V153.6zM989.9 938.7c0 28.2-23 51.2-51.2 51.2H85.3c-28.2 0-51.2-23-51.2-51.2V443.7h955.7V938.7zM989.9 409.6H34.1V221.9c0-28.2 23-51.2 51.2-51.2h17.1v51.2c0 28.2 23 51.2 51.2 51.2h34.1c28.2 0 51.2-23 51.2-51.2v-51.2h546.1v51.2c0 28.2 23 51.2 51.2 51.2h34.1c28.2 0 51.2-23 51.2-51.2v-51.2h17.1c28.2 0 51.2 23 51.2 51.2V409.6zM699.7 221.9H324.3c-9.4 0-17.1 7.6-17.1 17.1v102.4c0 9.4 7.6 17.1 17.1 17.1h375.5c9.4 0 17.1-7.6 17.1-17.1V238.9C716.8 229.5 709.2 221.9 699.7 221.9zM682.7 324.3H341.3V256h341.3V324.3zM221.9 494.9H119.5c-9.4 0-17.1 7.6-17.1 17.1v85.3c0 9.4 7.6 17.1 17.1 17.1h102.4c9.4 0 17.1-7.6 17.1-17.1V512C238.9 502.6 231.3 494.9 221.9 494.9zM204.8 580.3h-68.3v-51.2h68.3V580.3zM443.7 494.9H341.3c-9.4 0-17.1 7.6-17.1 17.1v85.3c0 9.4 7.6 17.1 17.1 17.1h102.4c9.4 0 17.1-7.6 17.1-17.1V512C460.8 502.6 453.2 494.9 443.7 494.9zM426.7 580.3h-68.3v-51.2h68.3V580.3zM682.7 494.9H580.3c-9.4 0-17.1 7.6-17.1 17.1v85.3c0 9.4 7.6 17.1 17.1 17.1h102.4c9.4 0 17.1-7.6 17.1-17.1V512C699.7 502.6 692.1 494.9 682.7 494.9zM665.6 580.3h-68.3v-51.2h68.3V580.3zM904.5 494.9H802.1c-9.4 0-17.1 7.6-17.1 17.1v85.3c0 9.4 7.6 17.1 17.1 17.1h102.4c9.4 0 17.1-7.6 17.1-17.1V512C921.6 502.6 914 494.9 904.5 494.9zM887.5 580.3h-68.3v-51.2h68.3V580.3zM221.9 665.6H119.5c-9.4 0-17.1 7.6-17.1 17.1V768c0 9.4 7.6 17.1 17.1 17.1h102.4c9.4 0 17.1-7.6 17.1-17.1v-85.3C238.9 673.2 231.3 665.6 221.9 665.6zM204.8 750.9h-68.3v-51.2h68.3V750.9zM443.7 665.6H341.3c-9.4 0-17.1 7.6-17.1 17.1V768c0 9.4 7.6 17.1 17.1 17.1h102.4c9.4 0 17.1-7.6 17.1-17.1v-85.3C460.8 673.2 453.2 665.6 443.7 665.6zM426.7 750.9h-68.3v-51.2h68.3V750.9zM682.7 665.6H580.3c-9.4 0-17.1 7.6-17.1 17.1V768c0 9.4 7.6 17.1 17.1 17.1h102.4c9.4 0 17.1-7.6 17.1-17.1v-85.3C699.7 673.2 692.1 665.6 682.7 665.6zM665.6 750.9h-68.3v-51.2h68.3V750.9zM904.5 665.6H802.1c-9.4 0-17.1 7.6-17.1 17.1V768c0 9.4 7.6 17.1 17.1 17.1h102.4c9.4 0 17.1-7.6 17.1-17.1v-85.3C921.6 673.2 914 665.6 904.5 665.6zM887.5 750.9h-68.3v-51.2h68.3V750.9zM221.9 836.3H119.5c-9.4 0-17.1 7.6-17.1 17.1v85.3c0 9.4 7.6 17.1 17.1 17.1h102.4c9.4 0 17.1-7.6 17.1-17.1v-85.3C238.9 843.9 231.3 836.3 221.9 836.3zM204.8 921.6h-68.3v-51.2h68.3V921.6zM443.7 836.3H341.3c-9.4 0-17.1 7.6-17.1 17.1v85.3c0 9.4 7.6 17.1 17.1 17.1h102.4c9.4 0 17.1-7.6 17.1-17.1v-85.3C460.8 843.9 453.2 836.3 443.7 836.3zM426.7 921.6h-68.3v-51.2h68.3V921.6zM686.6 825.3l-73.4 88 -38-38 -24.1 24.1 51.2 51.2c3.2 3.2 7.5 5 12.1 5 0.3 0 0.5 0 0.8 0 4.8-0.2 9.3-2.4 12.4-6.1l85.3-102.4L686.6 825.3zM891.4 825.3l-73.4 88 -38-38 -24.1 24.1 51.2 51.2c3.2 3.2 7.5 5 12.1 5 0.3 0 0.5 0 0.8 0 4.8-0.2 9.3-2.4 12.4-6.1l85.3-102.4L891.4 825.3z',
	  caret: 'M315.7 0L196.3 119.5 588.8 512 196.3 904.5 315.7 1024l512-512L315.7 0z',
	  climbing: 'M829.9 132.7c114.2 20.8 179.1 68.3 179.9 68.9 1.6 1.2 3.5 1.8 5.3 1.8 2.2 0 4.4-0.8 6.1-2.4 3.2-3 3.7-7.8 1.4-11.4C963.1 98.4 850.9 52.4 767.2 29.9c-90-24.2-164.9-27.2-168-27.3 -0.1 0-0.2 0-0.3 0H8.9C4.3 2.5 0.5 6 0 10.6s2.7 8.7 7.2 9.6c187.3 36 216.7 109.6 216.9 110.2 1.2 3.6 4.6 6 8.4 6h116.7v395.2c-15.6 5.1-27.1 21.4-27.1 40.6 0 10.7-2.3 15.5-5.2 21.6 -3.3 6.8-7 14.6-7 29.3 0 14.8 3.7 22.5 7 29.3 2.9 6.1 5.2 10.9 5.2 21.6 0 10.7-2.3 15.5-5.2 21.6 -3.3 6.8-7 14.6-7 29.3 0 14.8 3.7 22.5 7 29.3 2.9 6.1 5.2 10.9 5.2 21.6 0 10.7-2.3 15.5-5.2 21.6 -3.3 6.8-7 14.6-7 29.3 0 14.8 3.7 22.5 7 29.3 2.9 6.1 5.2 10.9 5.2 21.6 0 10.7-2.3 15.5-5.2 21.6 -3.3 6.8-7 14.6-7 29.3 0 14.8 3.7 22.5 7 29.3 2.9 6.1 5.2 10.9 5.2 21.6 0 0.1 0 0.3 0 0.4 0.4 22.9 17.1 41.4 37.4 41.4h70.5c20.7 0 37.5-19 37.5-42.3v-407c0-19.7-11.9-36.2-28.1-40.9V136.4H588c0.6 0 1.1-0.1 1.7-0.2 44.6-8.7 89-13.2 132.2-13.2C758.3 123.1 799.8 127.6 829.9 132.7zM449.7 572.2v407c0 13.5-8.8 24.5-19.6 24.5h-70.5c-10.8 0-19.6-11-19.6-24.5 0-0.1 0-0.2 0-0.2 -0.1-14.3-3.8-21.9-7-28.6 -2.9-6.1-5.2-10.9-5.2-21.6 0-10.7 2.3-15.5 5.2-21.6 3.3-6.8 7-14.6 7-29.3 0-14.8-3.7-22.5-7-29.3 -2.9-6.1-5.2-10.9-5.2-21.6s2.3-15.5 5.2-21.6c3.3-6.8 7-14.6 7-29.3 0-14.8-3.7-22.5-7-29.3 -2.9-6.1-5.2-10.9-5.2-21.6 0-10.7 2.3-15.5 5.2-21.6 3.3-6.8 7-14.6 7-29.3 0-14.8-3.7-22.5-7-29.3 -2.9-6.1-5.2-10.9-5.2-21.6 0-10.7 2.3-15.5 5.2-21.6 3.3-6.8 7-14.6 7-29.3 0-13.5 8.8-24.5 19.6-24.5h44v318.6c0 4.9 4 8.9 8.9 8.9s8.9-4 8.9-8.9V547.7h8.7C440.9 547.7 449.7 558.7 449.7 572.2zM421.7 529.9h-54.6V136.4h54.6V529.9zM894.5 129.5v-20.8c0-4.9-4-8.9-8.9-8.9s-8.9 4-8.9 8.9v15.8c-12.8-3.3-26.3-6.4-40.6-9V90.9c0-4.9-4-8.9-8.9-8.9s-8.9 4-8.9 8.9v21.6c-13-2-26.5-3.7-40.6-4.9V83.9c0-4.9-4-8.9-8.9-8.9s-8.9 4-8.9 8.9v22.4c-12.3-0.7-24.9-1.1-37.9-1.1 -0.9 0-1.8 0-2.7 0V73.2c0-4.9-4-8.9-8.9-8.9s-8.9 4-8.9 8.9v32.4c-13.5 0.4-27 1.3-40.6 2.5V59.2c0-4.9-4-8.9-8.9-8.9s-8.9 4-8.9 8.9v49.5c0 0.4 0.1 0.8 0.1 1.2 -18.5 2.2-37.2 5-55.8 8.6h-349c-9-16.7-43.5-64.1-155.3-98.2h515.9c3.8 0.2 77.7 3.5 163.9 26.7 68.2 18.4 156 52.7 215.5 115.2C957.4 151.8 929.4 139.8 894.5 129.5zM396.2 29.9c-20.9 0-37.9 17-37.9 37.9 0 20.9 17 37.9 37.9 37.9s37.9-17 37.9-37.9C434 46.9 417.1 29.9 396.2 29.9zM396.2 87.8c-11.1 0-20-9-20-20 0-11 9-20 20-20s20 9 20 20C416.2 78.8 407.2 87.8 396.2 87.8zM849.4 306.5H609c-24.9 0-45.2 20.3-45.2 45.2v297.2c0 0.5 0 0.9 0.1 1.4l0 0.1 0 0.6c0 0.7 0 1.4 0 2 0 72 58.6 130.6 130.6 130.6 65.9 0 124.4-49.2 133.3-112l66.6-318c0.1-0.6 0.2-1.2 0.2-1.8C894.5 326.8 874.3 306.5 849.4 306.5zM643.2 627.1l0-234.7c0-11.3 5.9-19.7 11.2-19.7h133.2c5.2 0 11 8.1 11.2 19.1L763 642.3c0 0.1 0 0.3 0 0.4 -4 40.1-30.3 70.4-61.3 70.4 -32.8 0-58.5-36.4-58.5-83 0-0.4 0-0.8 0-1.2l0-0.8c0-0.1 0-0.2 0-0.4L643.2 627.1zM810.4 436h48.5l-38.3 182.7h-36.2L810.4 436zM862.6 418.2h-49.6l3.5-24.5c0.1-0.4 0.1-0.8 0.1-1.3 0-21-12.7-37.5-29-37.5H654.4c-16.3 0-29 16.5-29 37.5v234.5c0 0.4 0 0.7 0 1l0 0.1 0 0.4c0 0.5 0 1.1 0 1.6 0 27.3 7.6 52.6 21.5 71.1 14.3 19.1 33.7 29.6 54.8 29.6 40.2 0 74.1-37.1 79-86.3l1.1-8.1h35l-6.6 31.5c0 0.2-0.1 0.4-0.1 0.6 -7.6 54.4-58.5 96.9-115.7 96.9 -62.2 0-112.7-50.6-112.7-112.7 0-0.5 0-1 0-1.4l0-1.1c0-0.2 0-0.3 0-0.5 0-0.3 0-0.6 0-0.8l0-0.2V351.7c0-15.1 12.3-27.3 27.3-27.3h240.4c14.8 0 26.9 11.8 27.3 26.5L862.6 418.2zM844.2 449.5c0.9-4.8-2.4-9.5-7.2-10.3 -4.9-0.8-9.5 2.4-10.3 7.2L798.8 602c-0.9 4.8 2.4 9.5 7.2 10.3 0.5 0.1 1.1 0.1 1.6 0.1 4.2 0 8-3 8.8-7.3L844.2 449.5z',
	  close: 'M1024 89L935 0 512 423 89 0 0 89l423 423L0 935l89 89 423-423 423 423 89-89L601 512 1024 89z',
	  facebook: 'M938.7 0H85.3C37.5 0 0 37.5 0 85.3v853.3c0 47.8 37.5 85.3 85.3 85.3h392.5 204.8 256c47.8 0 85.3-37.5 85.3-85.3V85.3C1024 37.5 986.5 0 938.7 0zM512 989.9V648.5H375.5V512H512V392.5c0-97.3 75.1-179.2 170.7-187.7h153.6v136.5H699.7c-29 0-51.2 22.2-51.2 51.2V512h170.7v136.5H648.5v341.3L512 989.9 512 989.9zM989.9 938.7c0 29-22.2 51.2-51.2 51.2h-256V682.7h170.7V477.9H682.7v-85.3c0-10.2 6.8-17.1 17.1-17.1h170.7V170.7H681c-114.3 10.2-203.1 107.5-203.1 221.9v85.3H341.3v204.8h136.5v307.2H85.3c-29 0-51.2-22.2-51.2-51.2V85.3c0-29 22.2-51.2 51.2-51.2h853.3c29 0 51.2 22.2 51.2 51.2L989.9 938.7 989.9 938.7z',
	  golf: 'M826.3 244.6C789.9 100.7 660.4 0 512 0 363.9 0 234.6 100.3 197.9 243.8s28.6 293.6 158.5 364.7c0 0.6-0.2 1.1-0.2 1.7 0 31.6 30.1 80.2 78.5 103.6 10.4 6.7 29.5 69.5 26.9 259.1 -0.3 18.2 9.2 35.1 24.9 44.3 15.7 9.2 35.1 9.1 50.8-0.1 15.7-9.2 25.2-26.2 24.8-44.4 -3.4-189.5 15.2-252.2 25.5-258.9 48.7-23.4 78.8-72 78.8-103.6 0-0.3-0.1-0.6-0.1-0.9C796.8 538.7 862.7 388.4 826.3 244.6zM572.9 683c-13.6 6.5-49.6 23.6-44.9 290.4 0.1 4.2-1.5 8.3-4.4 11.4 -6.5 6.3-16.8 6.3-23.2 0 -3-3-4.7-7.2-4.6-11.5 3.6-266.6-32.6-283.9-46.2-290.3C425 671.2 405.3 651 394.2 626c75.1 29.8 158.7 30 233.9 0.6C616.9 651.3 597.4 671.3 572.9 683zM512 614.3c-160.2 0-290.1-129.9-290.1-290.1S351.8 34.1 512 34.1 802.1 164 802.1 324.2C801.9 484.4 672.1 614.1 512 614.3zM313.7 428c-6.4-2.7-13.7-1.3-18.6 3.6 -6.6 6.7-6.6 17.5 0 24.2 0.8 0.8 1.7 1.5 2.7 2 0.9 0.7 1.9 1.2 2.9 1.5 1 0.5 2 0.8 3.1 1 1.1 0.2 2.3 0.3 3.4 0.3 2.2 0.1 4.5-0.4 6.5-1.4 2.1-0.9 4-2.1 5.6-3.6 6.6-6.7 6.6-17.5 0-24.2C317.7 430.1 315.8 428.8 313.7 428zM387.6 465.7c-0.9-0.7-1.7-1.4-2.6-2 -1-0.6-2-1.2-3.1-1.5 -1-0.5-2-0.8-3.1-1 -5.6-1.1-11.4 0.6-15.5 4.6 -3.1 3.3-4.9 7.6-4.9 12.1 0 1.1 0.1 2.3 0.3 3.4 0.2 1.1 0.5 2.1 1 3.1 0.4 1.1 0.9 2.1 1.5 3.1 0.7 0.8 1.4 1.7 2 2.6 3.3 3.1 7.6 4.9 12.1 4.9 1.1 0 2.3-0.1 3.4-0.3 1.1-0.2 2.1-0.5 3.1-1 1.1-0.4 2.1-0.9 3.1-1.5 1.9-1.2 3.4-2.7 4.6-4.6 0.6-1 1.2-2 1.5-3.1 0.5-1 0.8-2 1-3.1 0.2-1.1 0.3-2.3 0.3-3.4C392.5 473.3 390.7 469 387.6 465.7zM455.9 482.8c-1.6-1.5-3.5-2.8-5.6-3.6 -4.2-1.7-8.8-1.7-13 0 -2.1 0.9-4 2.1-5.6 3.6 -6.6 6.7-6.6 17.5 0 24.2 1.7 1.5 3.6 2.7 5.6 3.6 4.1 1.8 8.8 1.8 13 0 2.1-0.9 4-2.1 5.6-3.6C462.5 500.3 462.5 489.5 455.9 482.8L455.9 482.8zM419.2 531.9c-1-0.6-2-1.2-3.1-1.5 -1-0.5-2-0.8-3.1-1 -5.6-1.1-11.4 0.6-15.5 4.6 -3.1 3.3-4.9 7.6-4.9 12.1 0 1.1 0.1 2.3 0.3 3.4 0.2 1.1 0.5 2.1 1 3.1 0.4 1.1 0.9 2.1 1.5 3.1 0.7 0.8 1.4 1.7 2 2.6 3.3 3.1 7.6 4.9 12.1 4.9 1.1 0 2.3-0.1 3.4-0.3 1.1-0.2 2.1-0.5 3.1-1 1.1-0.4 2.1-0.9 3.1-1.5 0.8-0.7 1.7-1.4 2.6-2 0.7-0.9 1.4-1.7 2-2.6 0.6-1 1.2-2 1.5-3.1 0.5-1 0.8-2 1-3.1 0.2-1.1 0.3-2.3 0.3-3.4 -0.1-4.5-1.8-8.8-4.9-12.1C420.9 533.2 420.1 532.5 419.2 531.9zM490 551c-0.9-0.7-1.7-1.4-2.6-2 -1-0.6-2-1.2-3.1-1.5 -1-0.5-2-0.8-3.1-1 -5.6-1.1-11.4 0.6-15.5 4.6 -1.5 1.7-2.7 3.6-3.6 5.6 -0.9 2.1-1.3 4.3-1.4 6.5 0.1 4.5 1.8 8.8 4.9 12.1 0.8 0.7 1.7 1.4 2.6 2 0.9 0.6 2 1.2 3.1 1.5 1 0.5 2 0.8 3.1 1 1.1 0.2 2.3 0.3 3.4 0.3 1.1 0 2.3-0.1 3.4-0.3 1.1-0.2 2.1-0.5 3.1-1 1.1-0.4 2.1-0.9 3.1-1.5 0.9-0.6 1.7-1.3 2.6-2 3.1-3.3 4.9-7.6 4.9-12.1 0-2.2-0.5-4.4-1.4-6.5C492.7 554.6 491.5 552.7 490 551zM558.2 551c-1.7-1.5-3.6-2.7-5.6-3.6 -6.4-2.7-13.7-1.3-18.6 3.6 -1.5 1.7-2.7 3.6-3.6 5.6 -0.9 2.1-1.3 4.3-1.4 6.5 0 9.4 7.6 17.1 17.1 17.1s17.1-7.6 17.1-17.1c0-2.2-0.5-4.4-1.4-6.5C561 554.6 559.7 552.7 558.2 551zM623.9 531.9c-1-0.6-2-1.2-3.1-1.5 -1-0.5-2-0.8-3.1-1 -5.6-1.1-11.4 0.6-15.5 4.6 -3.1 3.3-4.9 7.6-4.9 12.1 0 1.1 0.1 2.3 0.3 3.4 0.2 1.1 0.5 2.1 1 3.1 0.4 1.1 0.9 2.1 1.5 3.1 0.7 0.8 1.4 1.7 2 2.6 3.3 3.1 7.6 4.9 12.1 4.9 1.1 0 2.3-0.1 3.4-0.3 1.1-0.2 2.1-0.5 3.1-1 1.1-0.4 2.1-0.9 3.1-1.5 0.8-0.7 1.7-1.4 2.6-2 0.7-0.9 1.4-1.7 2-2.6 0.6-1 1.2-2 1.5-3.1 0.5-1 0.8-2 1-3.1 0.2-1.1 0.3-2.3 0.3-3.4 -0.1-4.5-1.8-8.8-4.9-12.1C625.7 533.2 624.8 532.5 623.9 531.9zM524.1 482.8L524.1 482.8c-4.3-4.3-10.6-6-16.5-4.4 -5.9 1.6-10.5 6.2-12.1 12.1 -1.6 5.9 0.1 12.2 4.4 16.5 0.8 0.7 1.7 1.4 2.6 2 0.9 0.6 2 1.2 3.1 1.5 1 0.5 2 0.8 3.1 1 1.1 0.2 2.3 0.3 3.4 0.3 1.1 0 2.3-0.1 3.4-0.3 1.1-0.2 2.1-0.5 3.1-1 1.1-0.4 2.1-0.9 3.1-1.5 0.9-0.6 1.7-1.3 2.6-2C530.7 500.3 530.7 489.5 524.1 482.8zM592.4 482.8L592.4 482.8c-0.9-0.7-1.7-1.4-2.6-2.1 -1-0.6-2-1.2-3.1-1.5 -1-0.5-2-0.8-3.1-1 -5.6-1.1-11.4 0.7-15.5 4.6 -0.7 0.8-1.4 1.7-2 2.7 -0.7 0.9-1.2 1.9-1.5 2.9 -0.5 1-0.8 2-1 3.1 -0.2 1.1-0.3 2.3-0.3 3.4 0 4.5 1.7 8.9 4.9 12.1s7.6 5 12.1 4.9c1.1 0 2.3-0.1 3.4-0.3 1.1-0.2 2.1-0.5 3.1-1 1.1-0.4 2.1-0.9 3.1-1.5 0.9-0.6 1.7-1.3 2.6-2C599 500.3 599 489.5 592.4 482.8zM658.1 463.6c-1-0.6-2-1.2-3.1-1.5 -1-0.5-2-0.8-3.1-1 -5.6-1.1-11.4 0.6-15.5 4.6 -3.1 3.3-4.9 7.6-4.9 12.1 0 1.1 0.1 2.3 0.3 3.4 0.2 1.1 0.5 2.1 1 3.1 0.4 1.1 0.9 2.1 1.5 3.1 0.7 0.8 1.4 1.7 2 2.6 3.3 3.1 7.6 4.9 12.1 4.9 1.1 0 2.3-0.1 3.4-0.3 1.1-0.2 2.1-0.5 3.1-1 1.1-0.4 2.1-0.9 3.1-1.5 1.9-1.2 3.4-2.7 4.6-4.6 0.6-1 1.2-2 1.5-3.1 0.5-1 0.8-2 1-3.1 0.2-1.1 0.3-2.3 0.3-3.4 -0.1-4.5-1.8-8.8-4.9-12.1C659.8 465 658.9 464.3 658.1 463.6zM723.3 428c-4.1-1.9-8.9-1.9-13 0 -2.1 0.9-4 2.1-5.6 3.6 -3.1 3.3-4.9 7.6-4.9 12.1 0 1.1 0.1 2.3 0.3 3.4 0.2 1.1 0.5 2.1 1 3.1 0.4 1.1 0.9 2.1 1.5 3.1 0.7 0.8 1.4 1.7 2 2.6 1.7 1.5 3.6 2.7 5.6 3.6 4.1 1.8 8.8 1.8 13 0 2.1-0.9 4-2.1 5.6-3.6 0.7-0.9 1.4-1.7 2-2.6 0.6-1 1.2-2 1.5-3.1 0.5-1 0.8-2 1-3.1 0.2-1.1 0.3-2.3 0.3-3.4 -0.1-4.5-1.8-8.8-4.9-12.1C727.2 430.1 725.3 428.8 723.3 428zM285.2 346.2c-5-4.7-12.2-6.1-18.6-3.6 -2.1 0.9-4 2.1-5.6 3.6 -3.1 3.3-4.9 7.6-4.9 12.1 0 2.2 0.5 4.4 1.4 6.5 1.6 4.3 4.9 7.7 9.2 9.2 2.1 0.9 4.3 1.3 6.5 1.4 4.5-0.1 8.8-1.8 12.1-4.9 1.5-1.7 2.7-3.6 3.6-5.6 0.9-2.1 1.3-4.3 1.4-6.5C290.1 353.8 288.3 349.5 285.2 346.2zM357.1 386c-1.6-4.3-4.9-7.7-9.2-9.2 -4.2-1.7-8.8-1.7-13 0 -4.3 1.6-7.6 4.9-9.2 9.2 -0.9 2.1-1.3 4.3-1.4 6.5 0.1 4.5 1.8 8.8 4.9 12.1 1.7 1.5 3.6 2.7 5.6 3.6 4.1 1.8 8.8 1.8 13 0 2.1-0.9 4-2.1 5.6-3.6 3.1-3.3 4.9-7.6 4.9-12.1C358.4 390.2 357.9 388 357.1 386zM763 346.2c-1.7-1.5-3.6-2.7-5.6-3.6 -3.1-1.4-6.6-1.7-9.9-1 -1.1 0.2-2.1 0.5-3.1 1 -1.1 0.4-2.1 0.9-3.1 1.5 -0.9 0.6-1.8 1.3-2.6 2 -3.1 3.3-4.9 7.6-4.9 12.1 0 2.2 0.5 4.4 1.4 6.5 0.9 2.1 2.1 4 3.6 5.6 3.3 3.1 7.6 4.9 12.1 4.9 2.2 0 4.4-0.5 6.5-1.4 4.3-1.6 7.7-4.9 9.2-9.2 0.9-2.1 1.3-4.3 1.4-6.5C767.9 353.8 766.1 349.5 763 346.2zM698.3 386c-1.6-4.3-4.9-7.7-9.2-9.2 -4.2-1.7-8.8-1.7-13 0 -4.3 1.6-7.6 4.9-9.2 9.2 -0.9 2.1-1.3 4.3-1.4 6.5 0.1 4.5 1.8 8.8 4.9 12.1 1.7 1.5 3.6 2.7 5.6 3.6 4.1 1.8 8.8 1.8 13 0 2.1-0.9 4-2.1 5.6-3.6 3.1-3.3 4.9-7.6 4.9-12.1C699.7 390.2 699.2 388 698.3 386zM397.5 421.7c1.7 1.5 3.6 2.7 5.6 3.6 4.1 1.8 8.8 1.8 13 0 4.3-1.6 7.7-4.9 9.2-9.2 1.8-4.1 1.8-8.8 0-13 -1.6-4.3-4.9-7.7-9.2-9.2 -4.2-1.7-8.8-1.7-13 0 -4.3 1.6-7.6 4.9-9.2 9.2 -1.8 4.1-1.8 8.8 0 13C394.8 418.1 396 420 397.5 421.7zM477.9 443.7c4.5 0 8.9-1.7 12.1-4.9 3.2-3.2 5-7.6 4.9-12.1 0-1.1-0.1-2.3-0.3-3.4 -0.2-1.1-0.5-2.1-1-3.1 -0.3-1-0.9-2-1.5-2.9 -0.6-1-1.3-1.9-2-2.7 -6.8-6.3-17.4-6.3-24.2 0 -0.7 0.8-1.4 1.7-2 2.7 -0.7 0.9-1.2 1.9-1.5 2.9 -0.5 1-0.8 2-1 3.1 -0.2 1.1-0.3 2.3-0.3 3.4 0 4.5 1.7 8.9 4.9 12.1S473.3 443.7 477.9 443.7zM546.1 443.7c4.5 0 8.9-1.7 12.1-4.9s5-7.6 4.9-12.1c0-1.1-0.1-2.3-0.3-3.4 -0.2-1.1-0.5-2.1-1-3.1 -0.3-1-0.9-2-1.5-2.9 -0.6-1-1.3-1.9-2-2.7 -6.8-6.3-17.4-6.3-24.2 0 -0.8 0.8-1.5 1.7-2 2.7 -0.7 0.9-1.2 1.9-1.5 2.9 -0.5 1-0.8 2-1 3.1 -0.2 1.1-0.3 2.3-0.3 3.4 0 4.5 1.7 8.9 4.9 12.1C537.2 441.9 541.6 443.7 546.1 443.7zM602.3 421.7c3.3 3.1 7.6 4.9 12.1 4.9 2.2 0 4.4-0.5 6.5-1.4 2.1-0.8 4-2 5.6-3.6 1.5-1.7 2.7-3.6 3.6-5.6 1.8-4.1 1.8-8.8 0-13 -0.9-2.1-2.1-4-3.6-5.6 -1.6-1.5-3.5-2.8-5.6-3.6 -6.4-2.7-13.7-1.3-18.6 3.6 -1.5 1.7-2.7 3.6-3.6 5.6 -1.8 4.1-1.8 8.8 0 13C599.5 418.1 600.8 420 602.3 421.7z',
	  group: 'M1021.9 891.3l-40.6-141.1c-1-2.9-2.9-5.8-4.8-7.7 -25.1-76.4-87-135.3-165.3-155.6l-11.6-1.9c-17.4-4.8-36.7 1-49.3 15.5 -42.5 48.3-96.6 52.2-153.7 52.2 -57 0-111.1-3.9-153.7-52.2 -12.6-14.5-31.9-20.3-49.3-15.5l-11.6 2.9c-59 15.5-109.2 53.2-141.1 103.4H119.2c-1 0-1 0-1.9-1 0-1-1-1.9-1-3.9l25.1-89.9c22.2-70.6 64.8-91.8 147.9-113.1 3.9-1 6.8-2.9 8.7-4.8 6.8 5.8 14.5 10.6 22.2 14.5 2.9 1.9 5.8 1.9 8.7 1.9 6.8 0 13.5-3.9 17.4-10.6 4.8-9.7 1-21.3-8.7-26.1 -44.5-23.2-76.4-88.9-76.4-156.6 0-59.9 49.3-109.2 109.2-109.2 11.6 0 22.2 1.9 32.9 4.8 -10.6 26.1-16.4 54.1-16.4 84.1 0 165.3 99.5 304.4 217.5 304.4 116 0 218.4-142.1 218.4-304.4 0-120.8-97.6-218.4-218.4-218.4 -76.4 0-144 39.6-182.7 99.5 -16.4-5.8-33.8-8.7-51.2-8.7 -52.2 0-98.6 28-124.7 69.6 -1.9-1.9-3.9-2.9-5.8-3.9 -14.5-7.7-29-10.6-45.4-10.6 -54.1-1-97.6 42.5-97.6 96.6 0 30.9 8.7 59.9 22.2 83.1 -44.5 11.6-84.1 29-102.4 88L1.3 532.8c-2.9 9.7-1 20.3 4.8 28 5.8 8.7 16.4 13.5 27.1 13.5h74.4c-1 3.9-2.9 7.7-3.9 11.6l-25.1 90.8c-3.9 12.6-1 26.1 7.7 36.7 7.7 10.6 19.3 16.4 32.9 16.4h102.4c-2.9 6.8-4.8 13.5-6.8 20.3l-40.6 142.1c-3.9 16.4-1 33.8 9.7 47.4 10.6 13.5 26.1 21.3 42.5 21.3h579.9 32.9 130.5c16.4 0 32.9-7.7 42.5-21.3C1022.9 926.1 1026.8 908.7 1021.9 891.3zM444.9 200.3c1-1 1.9-1.9 2.9-3.9 1-1 1-2.9 1.9-3.9 30-54.1 88-90.8 154.6-90.8 80.2 0 147.9 53.2 171.1 125.6 -33.8 6.8-69.6-6.8-90.8-35.8 -6.8-8.7-18.4-10.6-27.1-3.9 -3.9 2.9-5.8 5.8-6.8 9.7 -1 1-1 1.9-1.9 2.9 -27.1 55.1-117.9 78.3-221.3 58C430.5 238 436.3 218.7 444.9 200.3zM499.1 303.7c77.3 0 141.1-24.2 174-69.6 24.2 21.3 54.1 32.9 86 32.9 7.7 0 16.4-1 24.2-2.9 1 5.8 1 10.6 1 16.4 0 142.1-84.1 266.8-179.8 266.8 -91.8 0-172-115-178.8-250.3C450.7 301.8 475.9 303.7 499.1 303.7zM41 535.7l13.5-48.3c11.6-39.6 35.8-51.2 84.1-62.8 2.9-1 5.8-1.9 7.7-3.9 4.8 3.9 8.7 6.8 14.5 9.7 2.9 1.9 5.8 1.9 8.7 1.9 6.8 0 13.5-3.9 17.4-10.6 4.8-9.7 1-21.3-7.7-26.1 -25.1-13.5-43.5-51.2-43.5-89.9 0-32.9 26.1-59 59-59 10.6 0 19.3 1.9 28 6.8 2.9 1 4.8 1.9 7.7 1.9 -4.8 14.5-7.7 30-7.7 46.4 0 55.1 18.4 109.2 47.4 146.9 -58 14.5-109.2 33.8-143 87H41L41 535.7zM982.3 916.5c-1.9 1.9-5.8 5.8-12.6 5.8H839.3h-32.9H226.5c-6.8 0-10.6-3.9-12.6-5.8 -2.9-3.9-3.9-9.7-2.9-13.5l40.6-141.1C271 695.1 324.1 643 391.8 625.6l11.6-2.9c2.9-1 7.7 1 10.6 3.9 53.2 60.9 118.9 65.7 182.7 65.7s129.5-4.8 182.7-65.7c2.9-2.9 6.8-4.8 11.6-3.9l11.6 2.9c66.7 17.4 120.8 69.6 140.1 136.3l17.4 59.9c1 2.9 1.9 4.8 3.9 6.8l21.3 73.5C986.2 906.8 985.2 912.6 982.3 916.5z',
	  house: 'M855.2 502.4c-16.6 0-29.5 12.8-29.5 29.5v403.4H616.4V770.6c0-15.5-12.9-29-28.4-29H436.6c-16.6 0-30.1 13.5-30.1 29v164.7H197.8v-390c0-15.6-12.9-28.5-29.5-28.5 -15.6 0-28.4 12.9-28.4 28.5v419.6c0 15.6 12.9 28.5 28.4 28.5h268.3c15.6 0 28.4-12.9 28.4-28.5V800.1h93.4v164.7c0 15.6 12.9 28.5 29.5 28.5h267.2c15.6 0 28.4-12.9 28.4-28.5v-433C883.6 515.2 870.8 502.4 855.2 502.4zM1015.6 525.4L782.8 291.5V132c0-16.6-13.4-29.4-30.1-29.4 -15.6 0-28.4 12.8-28.4 29.4v101L532.2 39.8c-5.9-6-12.9-9.2-19.9-9.2 -8 0-15 3.3-20.9 9.2L9 522.2C-2.6 533.8-3.3 552.3 9 563c10.7 12.4 29.2 11.6 40.8 0l462.6-461.5 461.5 465.8c4.8 4.8 11.8 7.6 20.9 7.6 8 0 15-2.7 20.9-7.6C1026.4 556.5 1027.2 537.1 1015.6 525.4z',
	  kayak: 'M1001.6 473c-14.2-12-32.8-17.2-51.3-14.1l-85 14.1c-18.2 3-32.4 15.7-38.1 32.3H702.3c-1.3-272-81.4-484.1-183.5-484.1 -102.1 0-182.2 212.1-183.5 484.1H196.8c-5.7-16.6-20-29.3-38.2-32.3l-84.9-14.1c-18.4-3-37.1 2.1-51.3 14.1C8.2 485.1 0 502.7 0 521.4c0 18.6 8.2 36.2 22.4 48.3 11.5 9.8 26 15 40.8 15 3.5 0 7-0.3 10.5-0.9l85-14.1c18.2-3 32.4-15.7 38.1-32.3h138.6c4.8 263 83.6 465.5 183.3 465.5 99.8 0 178.6-202.5 183.4-465.5h125.1c5.7 16.6 20 29.3 38.2 32.3l85 14.1c3.5 0.6 7 0.9 10.5 0.9 14.9 0 29.3-5.2 40.8-15 14.2-12 22.4-29.6 22.4-48.4C1024 502.7 1015.8 485.1 1001.6 473zM518.8 53.2c88.4 0 150.3 236.9 151.5 452.1h-52c-4.3-95.2-46.4-167.6-99.6-167.6 -53.1 0-95.2 72.4-99.6 167.6h-52C368.5 290 430.3 53.2 518.8 53.2zM451.2 505.3c4-80.7 37.4-135.6 67.6-135.6 30.2 0 63.6 54.9 67.6 135.6H451.2zM586.3 537.3c-4 80.7-37.4 135.6-67.6 135.6 -30.2 0-63.6-54.9-67.6-135.6H586.3zM153.4 538.1l-85 14.1h0c-9 1.5-18.3-1-25.4-7 -7-6-11.1-14.7-11.1-24 0-9.2 4-17.9 11.1-23.9 5.7-4.8 12.9-7.4 20.2-7.4 1.7 0 3.5 0.1 5.2 0.4l85 14.1c8.2 1.4 14.2 8.4 14.2 16.8C167.6 529.7 161.6 536.7 153.4 538.1zM518.8 970.8c-85.9 0-146.7-223.4-151.3-433.5h51.7c4.3 95.2 46.4 167.6 99.6 167.6s95.3-72.4 99.6-167.6H670C665.5 747.4 604.6 970.8 518.8 970.8zM980.9 545.2c-7 6-16.2 8.5-25.4 7 0 0 0 0 0 0l-84.9-14.1c-8.2-1.4-14.2-8.4-14.2-16.8 0-8.3 6-15.4 14.2-16.7l85-14.1c1.7-0.3 3.5-0.4 5.2-0.4 7.3 0 14.5 2.6 20.2 7.4 7 6 11.1 14.7 11.1 24C992 530.6 988 539.3 980.9 545.2z',
	  mail: 'M829.1 710.3c-4.1 0-8.1-1.5-11.3-4.5l-190-178.2c-6.6-6.2-7-16.7-0.7-23.3 6.2-6.7 16.6-7 23.3-0.7l190 178.2c6.6 6.2 7 16.7 0.7 23.3C837.9 708.5 833.5 710.3 829.1 710.3zM194.9 710.3c-4.4 0-8.8-1.8-12.1-5.2 -6.2-6.6-5.9-17.1 0.7-23.3l190.1-178.2c6.7-6.2 17.1-5.9 23.3 0.7 6.2 6.6 5.9 17.1-0.7 23.3L206.2 705.8C203 708.8 198.9 710.3 194.9 710.3zM941.5 876H82.5C37 876 0 839 0 793.4V230.6C0 185 37 148 82.5 148h858.9c45.5 0 82.5 37 82.5 82.5v562.9C1024 839 987 876 941.5 876zM82.5 181C55.2 181 33 203.3 33 230.6v562.9c0 27.3 22.2 49.5 49.5 49.5h858.9c27.3 0 49.5-22.2 49.5-49.5V230.6c0-27.3-22.2-49.5-49.5-49.5H82.5zM512 595c-22 0-43.9-7.3-60.6-21.9l-424-369.9c-6.9-6-7.6-16.4-1.6-23.3 6-6.9 16.4-7.5 23.3-1.6l424 369.8c21.1 18.4 56.8 18.4 77.8 0l423.4-369.2c6.8-6 17.2-5.3 23.3 1.6 6 6.9 5.3 17.3-1.6 23.3L572.6 573.1C555.9 587.7 534 595 512 595z',
	  mappin: 'M515.3 224.4c-72.2 0-130.9 58.7-130.9 130.9s58.7 130.9 130.9 130.9 130.9-58.7 130.9-130.9S587.5 224.4 515.3 224.4zM515.3 448.8c-51.6 0-93.5-41.9-93.5-93.5s41.9-93.5 93.5-93.5 93.5 41.9 93.5 93.5S566.9 448.8 515.3 448.8zM765.6 105C697.9 37.3 607.8 0 512 0c-95.8 0-185.8 37.3-253.6 105 -125.4 125.3-140.9 361.1-33.7 504L512 1024l286.9-414.4C906.5 466.2 891 230.4 765.6 105zM768.6 587.8L512 958.3l-257-371.1c-97.2-129.6-83.3-342.6 29.8-455.7C345.6 70.8 426.2 37.4 512 37.4s166.5 33.4 227.1 94.1C852.3 244.6 866.2 457.6 768.6 587.8z',
	  motorbike: 'M857.2 460.5c-22.5 0-43.9 4.5-63.5 12.6l-9.2-17.3c22.6-9.6 47.2-14.8 72.8-14.8 31.8 0 63.3 8.2 90.9 23.7 7.9 4.4 17.9 1.6 22.4-6.3 4.4-7.9 1.6-17.9-6.3-22.4 -32.5-18.3-69.5-27.9-107-27.9 -31.1 0-61 6.6-88.3 18.6l-16.3-30.5c1.5 0.1 3.1 0.2 4.6 0.2h38.1c9.1 0 16.4-7.4 16.4-16.4V273.7c0-9.1-7.4-16.4-16.4-16.4h-38.1c-25.8 0-48.2 14.5-59.6 35.8l-29-54.4c-2.9-5.4-8.4-8.7-14.5-8.7h-77.4c-9.1 0-16.4 7.4-16.4 16.4s7.4 16.4 16.4 16.4h67.6l27.9 52.4c-3.6-2.6-7.4-5.1-11.5-7.2 -24.8-13-54.7-13.8-80.1-2l-51.2 23.7c-18.5 8.6-33 22.7-42.2 39.7 -14.7-16.3-35.2-27.4-58.5-30.1l-249.5-28.2c-12.7-1.4-25.5 2.6-35.1 11.2 -9.6 8.5-15 20.8-15 33.6V428c-3.1 1.4-6.2 2.8-9.3 4.4C63.1 461.6 21.9 513.8 6.9 575.5c-2.1 8.8 3.3 17.7 12.1 19.9 1.3 0.3 2.6 0.5 3.9 0.5 7.4 0 14.1-5 16-12.6 12.8-52.4 47.7-96.8 96-121.6 17.2-8.9 37-13.6 57.1-13.6h22.7 263.6v47.7H322c-28.3-22-63.7-35.2-102.1-35.2 -85.7 0-156.9 65.5-165.8 149H16.4C7.4 609.5 0 616.9 0 626v54.7c0 9.1 7.4 16.4 16.4 16.4h52c27 58.5 86.5 97 151.5 97s124.5-38.5 151.5-97h113.3c35.9 0 65.4-27.5 68.7-62.5 30.5-11 56.4-32.9 72.2-62.6l77.9-152c4.4-11.7 6.2-23.8 5.7-35.7l30.9 57.9c-41.2 26.1-73.6 65.9-90.1 114.3 -2.9 8.6 1.6 17.9 10.2 20.9 1.8 0.6 3.6 0.9 5.3 0.9 6.8 0 13.2-4.3 15.6-11.1 13.8-40.4 40.5-73.6 74.5-95.9l9.2 17.3c-44.7 29.9-74.2 80.9-74.2 138.6 0 92 74.8 166.8 166.8 166.8S1024 719.3 1024 627.3 949.2 460.5 857.2 460.5zM214.7 415.2L214.7 415.2l-22.7 0h-30v-59.4c0-4.7 2.5-7.7 4.1-9.1 1.5-1.4 4.8-3.5 9.5-3L425 371.9c24.7 2.8 44.5 20.3 51 43.2L214.7 415.2 214.7 415.2zM421 528.6l42.1 80.9h-77.4c-3.2-30.1-14.5-57.7-31.6-80.9H421L421 528.6zM219.9 493.4c67.6 0 123.9 50.7 132.6 116.1H87.2C96 544.2 152.3 493.4 219.9 493.4zM219.9 761.2c-46.9 0-90.2-25-114.2-64.1h20.8c22 29.5 56.3 46.9 93.4 46.9 37.1 0 71.4-17.4 93.4-46.9h20.8C310.1 736.2 266.8 761.2 219.9 761.2zM173.6 697.1h92.7c-13.5 9-29.5 14-46.3 14C203.1 711.1 187.1 706.1 173.6 697.1zM484.6 664.2H32.9v-21.8h484.9C512.3 655.2 499.5 664.2 484.6 664.2zM596.5 556.6c-17.4 32.7-51.1 53-88.1 53h-8.2l-42.1-80.9h36.7c9.1 0 16.4-7.4 16.4-16.4v-64.1h143L596.5 556.6zM672.6 408.4l-2.5 6.7H509.7c-0.2-1.2-0.5-2.5-0.7-3.7 0.7-22 13.6-42.4 34.3-51.9l51.2-23.7c16.2-7.5 35.2-7 51 1.3C671.2 350.6 682.8 381.3 672.6 408.4zM722.6 328.8v-4c0-19.1 15.6-34.7 34.7-34.7h21.6v73.4h-21.6C738.2 363.6 722.6 348 722.6 328.8zM804.1 562.6l18.2 34.1c3 5.5 8.6 8.7 14.5 8.7 2.6 0 5.3-0.6 7.7-1.9 8-4.3 11-14.2 6.8-22.2l-18.2-34.1c7.6-2.3 15.7-3.6 24.1-3.6 46.2 0 83.8 37.6 83.8 83.8s-37.6 83.8-83.8 83.8 -83.8-37.6-83.8-83.8C773.5 601.3 785.4 578 804.1 562.6zM857.2 761.2c-73.8 0-133.9-60.1-133.9-133.9 0-45.2 22.5-85.2 56.9-109.4l8.2 15.3c-29 21.2-47.8 55.5-47.8 94.1 0 64.3 52.3 116.7 116.7 116.7s116.7-52.3 116.7-116.7 -52.3-116.7-116.7-116.7c-14 0-27.4 2.5-39.8 7l-8.2-15.3c14.9-5.7 31.1-8.9 48-8.9 73.8 0 133.9 60.1 133.9 133.9S931.1 761.2 857.2 761.2zM842.1 633.6C842.2 634 842.2 633.9 842.1 633.6c4.5 10.5 18.7 13.6 26.8 5.3 6.3-6.2 6.3-17.1 0-23.2 -5.4-5.5-14.4-6.3-20.8-2.1C841.6 617.9 839.2 626.3 842.1 633.6 841.9 633.3 841.9 633.1 842.1 633.6z',
	  mountainbikeHelmet: 'M551.3 933.8h30.4v30.4h-30.4V933.8zM551.3 812.1h30.4v30.4h-30.4V812.1zM551.3 872.9h30.4v30.4h-30.4V872.9zM848.6 105.8C798.4 52.7 731.9 17.5 660.5 5.1l-12.9-2.5v0.5c-11.1-1.5-22.2-2.4-33.5-2.8V0l-10.6 0.1c-0.2 0-0.5 0-0.7 0h0c-1.1 0-2.3 0-3.4 0l-0.5 0c-0.1 0-0.2 0-0.3 0 -4.8 0-9.6 0.1-14.4 0.2 -0.8 0-1.5 0-2.3 0.1 -4 0.1-8 0.3-11.9 0.4 -1.4 0.1-2.7 0.1-4.1 0.2 -2.9 0.1-5.8 0.3-8.8 0.5 -2.3 0.1-4.5 0.3-6.8 0.4 -0.1 0-0.1 0-0.2 0 -4.5 0.3-9 0.7-13.4 1.1l-13.8 1.2v0.2c-109.6 12.2-207.3 49.4-280.7 108C143.3 191.2 91 304.2 91 439v15.2h80.3c60.7 0 117.8 32.4 149 84.4 8.5 14.3 22.9 24.1 39 27.1l133.7 137.1v52.9 30.4V1024h143.9V786.1v-30.4 -49.6l139.9-78.2c7.1 1.5 14.4 2.3 21.9 2.3 61.5 0 111.5-49.7 112.1-111 1.8-13.6 19-142.7 21.7-188.5C937.2 248 907.4 168.1 848.6 105.8zM678 40c10.3 2.7 20.5 5.9 30.4 9.6v54.8c0 8.4-6.8 15.2-15.2 15.2 -8.4 0-15.2-6.8-15.2-15.2L678 40 678 40zM575.3 31c2.4-0.1 4.8-0.2 7.2-0.3 0.4 0 0.8 0 1.2 0V68c0 8.4-6.8 15.2-15.2 15.2 -8.4 0-15.2-6.8-15.2-15.2V32.3h0C560.7 31.7 568 31.3 575.3 31zM396.5 560.2c9.5-4.9 17.6-12.4 23.2-21.8l15.3-25.7 152.5 168.7h-72.8L396.5 560.2zM451.2 485.3l15.2-25.6c12.9-21.7 36.6-35.3 61.9-35.3 66.2 0 126.1 39.1 152.7 99.6 3.5 7.9 6.3 14.5 8.5 19.8l-124 67.9L451.2 485.3zM606.5 993.6h-83V786.1h83V993.6zM606.5 755.7h-83v-43.8h83V755.7zM625.3 677.8l-38.7-43L703 571c10.7 17.7 23.8 31.7 38.6 41.6L625.3 677.8zM902.1 328.9c-0.2 4-0.6 8.6-1 13.8h-95.3v30.4h92.3c-1.5 14.2-2.5 23.1-4.4 38.5H893h-87.2v30.4h84.3c-4.9 39.7-9.4 73.3-9.5 74l-0.1 1v1c0 45-36.6 81.7-81.7 81.7 -48 0-72.2-45.8-80.3-65.5 -2.3-5.7-5.6-13.2-9.6-22.4C677.4 440.2 606.6 394 528.3 394c-36 0-69.7 19.2-88.1 50.2l-46.7 78.8c-4.9 8.3-14 13.4-23.6 13.4 -9.6 0-18.6-5.1-23.5-13.3 -36.7-61.2-103.7-99.2-175.1-99.2h-49.7c7.6-240.7 194.9-363.7 401.2-388.5V68c0 25.2 20.5 45.6 45.6 45.6 25.2 0 45.6-20.5 45.6-45.6V30.7c11.2 0.4 22.4 1.5 33.5 3.1v70.7c0 25.2 20.5 45.6 45.6 45.6 25.2 0 45.6-20.5 45.6-45.6V62.2c32.6 16 62.4 37.8 87.6 64.5C879.5 182.8 906.4 254.7 902.1 328.9zM352.6 475.5H383v30.4h-30.4V475.5zM781 539h30.4v30.4H781V539z',
	  nav: 'M0 853.3h1024V739.6H0V853.3zM0 568.9h1024V455.1H0V568.9zM0 170.7v113.8h1024V170.7H0z',
	  nosmoking: 'M1004.3 498H728.6 559.3L998.4 58.8c7.9-7.9 7.9-19.7 0-27.6 -7.9-7.9-19.7-7.9-27.6 0L504.1 498H19.7C7.9 498 0 505.9 0 517.7v118.2c0 11.8 7.9 19.7 19.7 19.7h326.9l-321 321c-7.9 7.9-7.9 19.7 0 27.6 3.9 3.9 7.9 5.9 13.8 5.9s9.8-2 13.8-5.9l348.6-348.6h326.9 275.7c11.8 0 19.7-7.9 19.7-19.7V517.7C1024 505.9 1016.1 498 1004.3 498zM39.4 616.1v-78.8h425.4L386 616.1H39.4zM519.9 537.4h189v78.8H441.1L519.9 537.4zM984.6 616.1H748.3v-78.8h236.3L984.6 616.1 984.6 616.1zM39.4 466.5c11.8 0 19.7-7.9 19.7-19.7 0-92.6 43.3-165.4 98.5-165.4H256c9.8 0 17.7-5.9 19.7-15.8 2-7.9-2-15.8-7.9-19.7 -19.7-15.8-31.5-37.4-31.5-63 0-43.3 35.4-78.8 78.8-78.8 11.8 0 19.7-7.9 19.7-19.7s-7.9-19.7-19.7-19.7c-65 0-118.2 53.2-118.2 118.2 0 21.7 5.9 41.4 15.8 59.1h-55.1c-78.8 0-137.8 88.6-137.8 204.8C19.7 458.6 27.6 466.5 39.4 466.5zM366.3 51c29.5 13.8 47.3 41.4 47.3 72.9 0 43.3-35.4 78.8-78.8 78.8 -11.8 0-19.7 7.9-19.7 19.7 0 9.8 5.9 17.7 13.8 19.7 13.8 3.9 25.6 21.7 25.6 39.4 0 21.7-17.7 39.4-39.4 39.4H196.9c-57.1 0-98.5 53.2-98.5 126 0 11.8 7.9 19.7 19.7 19.7s19.7-7.9 19.7-19.7c0-49.2 25.6-86.6 59.1-86.6h118.2c43.3 0 78.8-35.4 78.8-78.8 0-15.8-5.9-33.5-15.8-47.3 43.3-17.7 74.8-61 74.8-110.3 0-47.3-27.6-88.6-70.9-108.3 -9.8-3.9-21.7 0-25.6 9.8C352.5 35.2 356.4 47 366.3 51z',
	  phone: 'M809.7 634.5c-21-21.9-46.3-33.5-73.2-33.5 -26.6 0-52.2 11.5-74 33.3l-68.4 68.2c-5.6-3-11.3-5.8-16.7-8.7 -7.8-3.9-15.2-7.6-21.4-11.5C492 641.7 433.8 588.6 377.9 520c-27.1-34.2-45.2-63-58.4-92.2 17.7-16.2 34.2-33.1 50.2-49.3 6.1-6.1 12.1-12.3 18.2-18.4 45.5-45.5 45.5-104.3 0-149.8l-59.1-59.1c-6.7-6.7-13.6-13.6-20.1-20.6 -13-13.4-26.6-27.3-40.7-40.3 -21-20.8-46.1-31.8-72.5-31.8s-51.9 11-73.6 31.8c-0.2 0.2-0.2 0.2-0.4 0.4l-73.6 74.2c-27.7 27.7-43.5 61.5-47 100.6 -5.2 63.2 13.4 122.1 27.7 160.6 35.1 94.6 87.4 182.2 165.6 276.2C289 815.7 403 905.1 533.3 968c49.8 23.6 116.2 51.5 190.5 56.3 4.5 0.2 9.3 0.4 13.6 0.4 50 0 92-18 124.9-53.7 0.2-0.4 0.6-0.6 0.9-1.1 11.3-13.6 24.2-26 37.9-39.2 9.3-8.9 18.8-18.2 28.1-27.9 21.4-22.3 32.7-48.3 32.7-74.9 0-26.8-11.5-52.6-33.3-74.2L809.7 634.5zM887.2 862.4C887 862.4 887 862.6 887.2 862.4c-8.4 9.1-17.1 17.3-26.4 26.4 -14.1 13.4-28.4 27.5-41.8 43.3 -21.9 23.4-47.6 34.4-81.4 34.4 -3.2 0-6.7 0-10-0.2 -64.3-4.1-124-29.2-168.8-50.6 -122.5-59.3-230.1-143.5-319.5-250.2 -73.8-89-123.2-171.2-155.8-259.5 -20.1-53.9-27.5-95.9-24.2-135.5 2.2-25.3 11.9-46.3 29.9-64.3l73.8-73.8c10.6-10 21.9-15.4 32.9-15.4 13.6 0 24.7 8.2 31.6 15.2 0.2 0.2 0.4 0.4 0.6 0.6 13.2 12.3 25.8 25.1 39 38.7 6.7 6.9 13.6 13.9 20.6 21l59.1 59.1c22.9 22.9 22.9 44.2 0 67.1 -6.3 6.3-12.3 12.6-18.6 18.6 -18.2 18.6-35.5 35.9-54.3 52.8 -0.4 0.4-0.9 0.6-1.1 1.1 -18.6 18.6-15.2 36.8-11.3 49.1 0.2 0.6 0.4 1.3 0.6 1.9 15.4 37.2 37 72.3 69.9 114.1l0.2 0.2C392 630.2 455 687.5 524.5 731.5c8.9 5.6 18 10.2 26.6 14.5 7.8 3.9 15.2 7.6 21.4 11.5 0.9 0.4 1.7 1.1 2.6 1.5 7.4 3.7 14.3 5.4 21.4 5.4 18 0 29.2-11.3 32.9-14.9l74-74c7.4-7.4 19-16.2 32.7-16.2 13.4 0 24.5 8.4 31.2 15.8 0.2 0.2 0.2 0.2 0.4 0.4L887 794.7C909.3 816.7 909.3 839.5 887.2 862.4zM553.5 243.2c56.7 9.5 108.2 36.4 149.3 77.5s67.7 92.6 77.5 149.3c2.4 14.3 14.7 24.2 28.8 24.2 1.7 0 3.2-0.2 5-0.4 16-2.6 26.6-17.7 24-33.8 -11.7-68.6-44.2-131.2-93.7-180.7 -49.6-49.6-112.1-82-180.7-93.7 -16-2.6-31 8-33.8 23.8S537.4 240.6 553.5 243.2zM1023.6 451.6c-19.3-113-72.5-215.8-154.3-297.6S684.6 19 571.6-0.3c-15.8-2.8-30.7 8-33.5 23.8 -2.6 16 8 31 24 33.8C663 74.4 755 122.2 828.1 195.1c73.2 73.2 120.8 165.1 137.9 266 2.4 14.3 14.7 24.2 28.8 24.2 1.7 0 3.2-0.2 5-0.4C1015.5 482.6 1026.4 467.4 1023.6 451.6z',
	  racebikeHelmet: 'M1023 411.3c-1.2-3.2-30-79.4-105.8-157.2 -44.5-45.6-96-82.3-153-108.9C693 112.1 613 94.5 526.3 93c-209.3-3.5-339.5 80.4-411.7 151.5C40.1 317.7 0 405.4 0 450.9c0 49.9 28.5 98.3 45.6 122.8 26.1 37.5 57.9 66.4 82.9 75.3 4.9 1.8 10.7 2.6 17.4 2.6 16.8 0 39.3-5.2 68-14L333 718.9c2.6 1.8 5.6 2.7 8.6 2.7 4.9 0 9.6-2.3 12.6-6.6 4.7-6.9 3-16.4-4-21.1l-99.7-68.2c9.8-3.3 20.2-6.9 31.1-10.7l180.9 123.6c2.6 1.8 5.6 2.7 8.6 2.7 3.7 0 7.4-1.3 10.3-4L642.4 590c13.3-0.2 26.9-0.6 40.6-1.4L474.7 778.9l-71-48.5c-6.9-4.7-16.4-3-21.1 4 -4.7 6.9-3 16.4 4 21.1l253 172.9c2.6 1.8 5.6 2.7 8.6 2.7 3.7 0 7.4-1.3 10.3-4l43-39.3c3.4-3.1 5.2-7.7 4.9-12.3 -0.3-4.6-2.8-8.9-6.6-11.5L543.5 757.2l189.2-172.9c143.6-17 241-70.9 289.4-160.5C1024.3 420 1024.6 415.4 1023 411.3zM666.7 878.3l-20 18.3 -146.3-100 20-18.3L666.7 878.3zM469.6 706.7L317.3 602.6c46.1-15.7 91.8-29.8 113.8-27.6 4.5 0.5 11 1.3 19.1 2.3 29.8 3.7 84 10.5 147.6 12.3L469.6 706.7zM735.7 426.1c-8.4 0.4-14.9 7.5-14.5 15.8 0.3 8.2 7.1 14.5 15.2 14.5 0.2 0 0.4 0 0.7 0 79.1-3.4 158.9-8.6 237.7-15.6 -48.9 62.3-132.4 100.5-249 113.7 -111.2 12.6-223.7-1.5-271.8-7.5 -8.4-1-15-1.9-19.9-2.4 -33.7-3.4-94.4 17.7-158.6 40.1 -50.5 17.6-119.6 41.6-136.8 35.5C103 607.6 30.4 521.1 30.4 450.9c0-3.3 0.3-7 1-11.1C189.7 454.1 350 461.4 510 461.4c54.1 0 108.2-0.8 162.2-2.5 8.4-0.3 15-7.3 14.7-15.7 -0.3-8.4-7.2-15-15.7-14.7 -210.5 6.5-423 0.2-631.9-18.6 11-30.6 32.3-70.1 65.2-109.7 51.9-33.3 110.8-59.4 175.2-77.4 75.8-21.2 159.6-31.3 248.9-30.1 80.3 1.1 155.9 12.1 224.7 32.7 8 2.4 16.5-2.2 18.9-10.2 2.4-8-2.2-16.5-10.2-18.9 -71.5-21.4-149.9-32.8-233-34 -92.3-1.3-178.9 9.2-257.5 31.2 -29.5 8.3-57.9 18.1-85.1 29.6 70.8-52.2 176.7-99.7 327.1-99.7 4 0 8.1 0 12.1 0.1 82.1 1.4 157.7 17.9 224.9 49 53.7 24.9 102.1 59.2 144 102 53.9 55 83.1 110.3 94.4 134.6C905.1 416.7 820 422.5 735.7 426.1zM937.8 361.1C825 287 687.5 248.4 529.1 246.1c-92.3-1.3-178.9 9.2-257.5 31.2 -8.1 2.3-12.8 10.6-10.5 18.7s10.6 12.8 18.7 10.5c75.8-21.2 159.6-31.3 248.9-30.1 152.5 2.1 284.5 39.1 392.4 110 2.6 1.7 5.5 2.5 8.3 2.5 4.9 0 9.8-2.4 12.7-6.9C946.8 375.2 944.8 365.7 937.8 361.1zM241 302.5c-2.8-7.9-11.5-12-19.4-9.2 -48.7 17.5-94.3 39.8-135.3 66.4 -7 4.6-9.1 14-4.5 21 2.9 4.5 7.8 6.9 12.8 6.9 2.8 0 5.7-0.8 8.3-2.4 39.1-25.3 82.5-46.6 129-63.3C239.7 319.1 243.8 310.4 241 302.5z',
	  sign: 'M1013 542.2L831.7 399.9c-4-4-9.5-6-16-6H539.5v-50.9h305.7c15.5 0 27.5-12.5 27.5-28V29.7c0-15.5-12-27.5-27.5-27.5H208.8c-6.5 0-12.5 2-17.5 6L10.5 150.6C3.2 156.3 0 164.1 0 173.1c0 8.5 3.2 15.8 10.5 21.5l180.8 141.9c5.6 4.4 11 6.5 17.5 6.5H484v50.9H179.3c-7.5 0-14 2.5-19.5 8 -5.5 5.5-8.5 12-8.5 19.5v285.7c0 15.5 12.5 27.5 28 27.5H484v259.7c0 15.5 12 27.5 27.5 27.5 15.5 0 28-12 28-27.5V734.5h276.2c6.5 0 12-2 16-6L1013 586.2c7.3-5.7 11-13 11-22.5C1024 554.7 1020.3 548 1013 542.2zM217.8 287.5L72.9 173.1 217.8 57.2h599.9v230.3H539.5 484L217.8 287.5 217.8 287.5zM805.2 679.1H539.5 484 206.8V449.3H484h55.4 265.7l146.4 114.4L805.2 679.1z',
	  skis: 'M1019.2 159.4c-5-7.5-13.6-11.7-23.5-11.7 -5.4 0-11.3 1.3-17.5 3.7l-58.4 23.4c-20 8-47.5 26.2-62.7 41.4L537.3 535.9c-18.6 2.6-35.7 11.1-49.2 24.6 -6.8 6.8-6.8 17.8 0 24.6l0 0L162.9 910.3c-9.8 9.8-15.2 22.9-15.2 36.9 0 14 5.4 27.1 15.2 36.9l24.6 24.6c9.8 9.8 22.9 15.2 36.9 15.2 14 0 27.1-5.4 36.9-15.2l325.2-325.2c3.4 3.4 7.8 5.1 12.3 5.1 4.5 0 8.9-1.7 12.3-5.1 13.5-13.5 22-30.6 24.6-49.2l319.8-319.8c15.2-15.2 33.4-42.8 41.4-62.7l23.4-58.4C1027 176.5 1023.4 165.6 1019.2 159.4zM598.8 622l-49.2-49.2 2.9-2.9c12.8 0.7 24.8 6 34 15.2 9.2 9.2 14.5 21.2 15.2 34L598.8 622zM236.7 984.1c-3.3 3.3-7.6 5.1-12.3 5.1 -4.7 0-9-1.8-12.3-5.1l-24.6-24.6c-3.3-3.3-5.1-7.6-5.1-12.3 0-4.7 1.8-9 5.1-12.3L525 597.4l49.2 49.2L236.7 984.1zM964.6 238.8c-6.3 15.7-21.7 39.1-33.7 51.1L630.6 590.2c-4.3-11-10.9-21.1-19.5-29.7 -8.6-8.6-18.7-15.2-29.7-19.5l300.4-300.4c12-12 35.4-27.4 51.1-33.7l53-21.2L964.6 238.8zM488.1 683.5c-3.2-3.2-7.7-5.1-12.3-5.1 -4.6 0-9 1.8-12.3 5.1 -3.2 3.2-5.1 7.7-5.1 12.3 0 4.6 1.9 9 5.1 12.3 3.2 3.2 7.7 5.1 12.3 5.1 4.6 0 9.1-1.9 12.3-5.1s5.1-7.7 5.1-12.3C493.2 691.2 491.3 686.8 488.1 683.5zM451.2 541c4.5 0 8.9-1.7 12.3-5.1 13.5-13.5 22-30.6 24.6-49.2l319.8-319.8c15.2-15.2 33.4-42.8 41.4-62.7l23.4-58.4c6.7-16.8 3.1-27.8-1.1-34C866.5 4.3 858 0 848.1 0c-5.4 0-11.3 1.3-17.5 3.7l-58.4 23.4c-20 8-47.5 26.2-62.7 41.4L389.6 388.4c-18 2.6-35.3 10.7-49.2 24.6 -6.8 6.8-6.8 17.8 0 24.6l0 0L15.2 762.7C5.4 772.6 0 785.7 0 799.6c0 14 5.4 27.1 15.2 36.9l24.6 24.6c9.8 9.8 22.9 15.2 36.9 15.2s27.1-5.4 36.9-15.2l325.2-325.2C442.3 539.3 446.7 541 451.2 541zM404.8 422.4c12.4 0.7 24.6 5.7 34.1 15.1 9.2 9.2 14.5 21.2 15.2 34l-2.9 2.9L402 425.2 404.8 422.4zM734.1 93.1c12-12 35.4-27.4 51.1-33.7l53-21.2 -21.2 53c-6.3 15.7-21.7 39.1-33.7 51.1L483 442.6c-4.3-11-10.9-21.1-19.5-29.7 -8.7-8.7-18.9-15.2-29.8-19.5L734.1 93.1zM89 836.5c-3.3 3.3-7.6 5.1-12.3 5.1s-9-1.8-12.3-5.1l-24.6-24.6c-3.3-3.3-5.1-7.6-5.1-12.3 0-4.7 1.8-9 5.1-12.3l337.5-337.5 49.2 49.2L89 836.5zM340.5 535.9c-3.2-3.2-7.7-5.1-12.3-5.1 -4.6 0-9 1.8-12.3 5.1 -3.2 3.2-5.1 7.7-5.1 12.3 0 4.6 1.9 9 5.1 12.3 3.2 3.2 7.7 5.1 12.3 5.1 4.6 0 9.1-1.8 12.3-5.1 3.2-3.2 5.1-7.7 5.1-12.3C345.5 543.6 343.7 539.2 340.5 535.9z',
	  target: 'M1022.2 101.4c-3.2-6.3-10.1-9.9-17.1-8.8l-87.2 13.4 13.4-87.2c1.1-7-2.5-13.9-8.8-17.1 -6.3-3.2-13.9-2-18.9 3L802.4 106.1c-2.5 2.5-4.1 5.6-4.6 9.1l-16 104 -58 58C643.9 203 540.6 162.3 430.9 162.3c-115.2 0-223.4 44.8-304.7 126.1C44.8 369.8 0 478 0 593.1s44.8 223.4 126.1 304.7c81.3 81.3 189.6 126.1 304.7 126.1s223.4-44.8 304.7-126.1c81.3-81.3 126.1-189.6 126.1-304.7 0-91.6-28.3-179.1-81.9-252.9 -5.3-7.3-15.5-8.9-22.8-3.6 -7.3 5.3-8.9 15.5-3.6 22.8 49.5 68.2 75.7 149 75.7 233.7 0 219.6-178.6 398.2-398.2 398.2S32.7 812.7 32.7 593.1 211.3 195 430.9 195c101 0 196.1 37.3 269.8 105.2L626 374.9c-53.7-48.1-122.5-74.5-195.1-74.5 -161.4 0-292.7 131.3-292.7 292.7s131.3 292.7 292.7 292.7 292.7-131.3 292.7-292.7c0-53.9-14.7-106.5-42.6-152.2 -4.7-7.7-14.8-10.1-22.5-5.4 -7.7 4.7-10.1 14.8-5.4 22.5 24.7 40.6 37.8 87.3 37.8 135.2 0 143.4-116.6 260-260 260 -143.4 0-260-116.6-260-260s116.6-260 260-260c63.9 0 124.5 23 172 64.9L528 472.9c-27.4-22.2-61.3-34.3-97.1-34.3 -85.2 0-154.5 69.3-154.5 154.5s69.3 154.5 154.5 154.5c85.2 0 154.5-69.3 154.5-154.5 0-15.2-2.2-30.2-6.5-44.6 -2.6-8.6-11.7-13.5-20.4-10.9 -8.6 2.6-13.5 11.7-10.9 20.4 3.4 11.4 5.1 23.2 5.1 35.2 0 67.2-54.7 121.8-121.8 121.8S309 660.3 309 593.2c0-67.2 54.7-121.8 121.8-121.8 27.1 0 52.7 8.8 73.8 24.9l-85.4 85.4c-6.4 6.4-6.4 16.7 0 23.1 3.2 3.2 7.4 4.8 11.6 4.8 4.2 0 8.4-1.6 11.6-4.8l293.1-293.1c0.1-0.1 69.3-69.3 69.3-69.3l104-16c3.4-0.5 6.6-2.1 9.1-4.6l101.3-101.3C1024.2 115.3 1025.4 107.7 1022.2 101.4L1022.2 101.4zM829.3 125.4l62.2-62.2 -8.4 54.6L820.9 180 829.3 125.4zM898.6 194.7l-54.6 8.4 62.2-62.2 54.6-8.4C960.8 132.5 898.6 194.7 898.6 194.7z',
	  tree: 'M585.1 1024H438.9V831.7H135l220.3-293.9H205.9l174-232.2h-96.9L512 0l228.9 305.5H644l174.1 232.2H668.7L889 831.7H585.1C585.1 831.7 585.1 1024 585.1 1024zM481.7 981.2h60.5V788.8h261.1L583 494.9h149.4l-174-232.2h96.9L512 71.5 368.7 262.7h96.9l-174 232.2h149.4L220.6 788.8h261.1C481.7 788.8 481.7 981.2 481.7 981.2z',
	  twitter: 'M1018.1 188.8c-5.2-5.2-13.9-7-20.9-5.2l-34.8 12.2c20.9-24.3 34.8-50.4 43.5-74.7 3.5-8.7 1.7-15.6-3.5-20.9 -5.2-5.2-13.9-7-20.9-3.5 -48.7 20.9-90.4 38.2-125.1 48.7 0 1.7-1.7 0-3.5 0 -27.8-15.6-95.6-50.4-144.3-50.4 -123.4 1.7-222.5 106-222.5 232.9v7C305.5 300 206.5 247.8 98.7 134.9l-17.4-17.4 -10.4 20.9c-59.1 113-17.4 215.5 50.4 285C90 418.2 69.1 407.8 50 392.1c-7-5.2-15.6-7-24.3-1.7 -7 3.5-10.4 13.9-8.7 22.6 24.3 81.7 85.2 147.7 151.2 187.7 -31.3 0-57.4-3.5-83.4-20.9 -7-3.5-17.4-3.5-24.3 1.7s-10.4 13.9-7 22.6c31.3 88.6 92.1 135.6 189.5 147.7 -50.4 29.5-116.5 53.9-219 55.6 -10.4 0-19.1 7-22.6 15.6 -3.5 10.4 0 19.1 7 26.1 62.6 50.4 201.6 80 373.7 80 305.9 0 556.2-272.9 556.2-608.3v-5.2c38.2-19.1 69.5-55.6 85.2-106C1025.1 202.7 1023.3 194 1018.1 188.8zM913.8 287.8l-10.4 3.5v29.5c0 316.3-234.6 573.6-521.4 573.6 -158.2 0-264.2-26.1-321.5-53.9 119.9-8.7 189.5-46.9 243.3-88.6l43.5-31.3h-52.1c-99.1 0-159.9-27.8-194.7-93.9 31.3 10.4 64.3 10.4 100.8 8.7 13.9-1.7 27.8-1.7 41.7-1.7l5.2-34.8c-66-19.1-144.3-78.2-182.5-158.2 34.8 15.6 73 19.1 107.8 19.1h53.9l-43.4-31.3c-36.5-26.1-144.3-118.2-92.1-250.3C203 287.8 309 338.2 500.2 373l20.9 3.5v-48.7c0-107.8 83.4-196.4 187.7-198.1 40-1.7 106 34.8 125.1 45.2 10.4 5.2 20.9 7 31.3 3.5 26.1-8.7 57.4-20.9 92.1-34.8 -15.6 26.1-36.5 50.4-64.3 73 -7 5.2-8.7 15.6-5.2 24.3 3.5 8.7 13.9 12.2 22.6 8.7l67.8-22.6C966 249.6 946.9 275.7 913.8 287.8z',
	  whatsapp: 'M512 0C229.7 0 0 229.7 0 512c0 96.3 26.8 189.8 77.5 271 -20.2 70.9-56.8 204.9-57.1 206.3 -1.9 6.9 0.1 14.3 5.3 19.3s12.7 6.8 19.5 4.7l202.9-62.4c79.5 47.9 170.5 73.2 263.9 73.2 282.3 0 512-229.7 512-512S794.3 0 512 0zM512 984.5c-89 0-175.7-24.9-250.7-71.9 -3.2-2-6.8-3-10.5-3 -1.9 0-3.9 0.3-5.8 0.9L67.8 965c13-47.5 36.4-132.5 50-179.8 1.6-5.5 0.7-11.4-2.4-16.2 -49.7-76.5-76-165.5-76-257.2 0-260.6 212-472.6 472.6-472.6s472.6 212 472.6 472.6S772.6 984.5 512 984.5zM846.5 632.5c-36.4-20.2-67.3-40.4-89.9-55.2 -17.3-11.3-29.7-19.4-38.9-24 -25.5-12.7-44.9-3.7-52.3 3.7 -0.9 0.9-1.8 1.9-2.5 3 -26.5 39.8-61.2 77.9-71.3 79.9 -11.7-1.8-66.6-33-121.1-78.4 -55.7-46.4-90.7-90.8-95.8-121 35.7-36.7 48.6-59.9 48.6-86.2 0-27.1-63.3-140.3-74.7-151.8 -11.5-11.5-37.3-13.3-76.9-5.4 -3.8 0.8-7.3 2.6-10.1 5.4 -4.6 4.9-116.6 119-63.4 257.4 58.4 151.8 208.3 328.3 399.5 357 21.7 3.2 42.1 4.9 61.1 4.9 112.4 0 178.8-56.6 197.5-168.8C857.7 644.8 853.8 636.6 846.5 632.5zM603.5 778C401.4 747.7 274.1 547.4 235 445.9c-38.8-100.8 32.7-190.7 50.7-211 14.6-2.5 30-3.5 36.4-2.5 13.4 18.6 59.8 106.4 61.9 122.2 0 10.3-3.4 24.7-43.5 64.8 -3.7 3.7-5.8 8.7-5.8 13.9 0 103.1 217.5 246.2 256 246.2 33.5 0 77.2-56.3 102-93 1.4 0.1 3.9 0.6 7.3 2.3 7.1 3.6 19.4 11.6 34.9 21.7 20.5 13.4 47.8 31.2 80 49.7C800.4 730.3 759.5 801.4 603.5 778z',
	  wifi: 'M798.6 555.2c-0.3-11.8-5.6-23.1-14.4-30.9C709.3 457.7 612.7 421 512 421s-197.3 36.7-272.2 103.3c-8.8 7.8-14 19.1-14.4 30.9 -0.3 11.9 4.3 23.5 12.7 31.9l82.2 82.2c16 16 41.1 17.1 58.4 2.5 37.1-31.2 84.4-48.4 133.2-48.4 48.8 0 96.1 17.2 133.2 48.4 8.1 6.9 18 10.2 27.8 10.2 11.1 0 22.1-4.3 30.6-12.8l82.2-82.2C794.3 578.7 798.9 567.1 798.6 555.2zM673.1 638.8L673.1 638.8C628.2 601 571 580.2 512 580.2c-59 0-116.2 20.8-161 58.6l-82.4-82.1c66.9-59.6 153.3-92.4 243.4-92.4s176.5 32.8 243.3 92.3L673.1 638.8zM576.4 766c-17.2-17.2-40.1-26.7-64.4-26.7 -24.3 0-47.2 9.5-64.4 26.7 -35.5 35.5-35.5 93.3 0 128.8 17.7 17.7 41.1 26.6 64.4 26.6 23.3 0 46.6-8.9 64.4-26.6 17.2-17.2 26.7-40.1 26.7-64.4C603 806.1 593.6 783.2 576.4 766zM545.8 864.2c-18.6 18.6-48.9 18.6-67.6 0 -18.6-18.6-18.6-48.9 0-67.6 9-9 21-14 33.8-14 12.8 0 24.8 5 33.8 14 0 0 0 0 0 0 9 9 14 21 14 33.8C559.8 843.2 554.8 855.2 545.8 864.2zM1010.3 299.4C730.9 37 293.1 37 13.7 299.4c-8.7 8.1-13.5 19.1-13.7 31 -0.2 11.8 4.3 22.9 12.7 31.2l82.1 82.1c16.5 16.5 42.8 17 59.9 1.2C251.9 354.7 378.8 305 512 305c133.2 0 260.1 49.7 357.3 139.9 8.3 7.7 18.8 11.6 29.3 11.6 11.1 0 22.1-4.3 30.6-12.7l82.1-82.1c8.3-8.3 12.8-19.4 12.7-31.2C1023.8 318.6 1018.9 307.6 1010.3 299.4zM898.7 413.2C793.5 315.6 656.2 261.8 512 261.8c-144.2 0-281.5 53.8-386.7 151.4l-82-82.2c262.8-246.8 674.5-246.8 937.3 0l0.1 0.1L898.7 413.2z'
	};
	
	exports.default = icons;
	module.exports = exports['default'];

/***/ }),

/***/ 189:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(36);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Icon = __webpack_require__(27);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _localization = __webpack_require__(191);
	
	var _localization2 = _interopRequireDefault(_localization);
	
	var _common = __webpack_require__(28);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _badgesMap = __webpack_require__(399);
	
	var _badgesMap2 = _interopRequireDefault(_badgesMap);
	
	var _BadgesModule = __webpack_require__(302);
	
	var _BadgesModule2 = _interopRequireDefault(_BadgesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Badges = function Badges(props) {
	  var language = props.language;
	
	
	  return _react2.default.createElement(
	    'section',
	    { className: _BadgesModule2.default.badges },
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: _localization2.default[language].locationTarget, className: [_BadgesModule2.default.badge, _BadgesModule2.default.badgeLocation].join(' ') },
	      _react2.default.createElement(
	        'div',
	        { className: _BadgesModule2.default.badgeLocationMap },
	        _react2.default.createElement(
	          'svg',
	          { xmlns: 'http://www.w3.org/2000/svg', width: '100%', viewBox: '0 0 71.55 100' },
	          _react2.default.createElement('path', { d: 'M22.3 0c-.06 0-.1.13-.2.11a3 3 0 0 0-.25.63 4.47 4.47 0 0 1-.29.53c-.13.24-.24.27-.39.44a3.32 3.32 0 0 1-.34.29l-.05.2c-.1.21-.21.46-.29.63a4.5 4.5 0 0 0-.19.68 5.54 5.54 0 0 0-.1.68c0 .19-.09.41-.15.63-.09.41.28.12.34.15a3.16 3.16 0 0 0 .29-.63 3.21 3.21 0 0 0 .1-.63c0-.15.07-.43.1-.58s.24-.38.34-.53c.27-.43.13 0 .29.09l.49.2c.26.1.07-.34.09-.44.06-.27-.13-.46-.19-.68v-.28a2.3 2.3 0 0 0 .29-.49 2.16 2.16 0 0 1 .49-.35c.15-.1-.16-.32-.25-.49S22.33 0 22.3 0zm.7 3.43c-.37 0-.05.7-.05.7-.06.3.46.69.55.83s.09.61.14 1a5.87 5.87 0 0 1 0 1c0 .32.36.32.62.55a5.25 5.25 0 0 0 .76.48c.25.16.1.7.14 1 .07.48-.25.49-.41.83s-.64.21-.83.28a9.34 9.34 0 0 0-.89.41c-.32.15-.38.43-.55.62s.18.55.28.83.73-.24.83-.28a3.76 3.76 0 0 0 .76-.48c.12-.07.28 0 .41.07s-.32.46-.48.69-.3.48-.48.76.33.44.41.55.62.06.76.07.45.45.55.55c.33.33 0 .53.07.83s-.5 0-.76-.07c-.77-.07.1-.05-.41.21-.29.14.23.6.34.89.2.52.3.26.62.55a6.72 6.72 0 0 0 .89.28c.36.11.54.21.89.34a3.91 3.91 0 0 1 .83.55 2.76 2.76 0 0 1 .55.69 3.19 3.19 0 0 1 .34.76l.34.76a6.26 6.26 0 0 0 .48.76 1.89 1.89 0 0 0 .18.24l-.25-.12a1.5 1.5 0 0 1-.34-.35 3.76 3.76 0 0 1-.26-.34l-.34-.48a3.07 3.07 0 0 0-.43-.39 4.34 4.34 0 0 0-.43-.3 2.36 2.36 0 0 1-.3-.48l-.31-.48c-.1-.16-.17-.15-.3-.26a1.18 1.18 0 0 0-.43-.18c-.26-.1-.28 0-.52 0a1.78 1.78 0 0 0-.52.09 4.81 4.81 0 0 0-.56.17c-.25.08-.37 0-.65 0a2 2 0 0 1-.56-.18c-.15 0-.28-.31-.34-.39l-.26-.31c-.18-.22-.27-.09-.52-.17s-.39.19-.52.26c-.3.15-.13.24-.26.48a5.43 5.43 0 0 0-.17.65s-.29.36-.35.43-.06.39-.09.61a1.61 1.61 0 0 0 0 .65c.23.81-.12.91-.13 1.08a2.51 2.51 0 0 1-.69-.43c-.09-.12-.2-.28-.3-.43s-.49.19-.56.22-.07.47-.09.61.21.43.26.52a2.21 2.21 0 0 1 0 .69c0 .26-.14.41-.22.61s-.31.22-.43.31-.19-.08-.39-.18a3.57 3.57 0 0 1-.26-.43l-.26-.43a4.09 4.09 0 0 0-.35-.39c-.15-.17.2-.45.22-.48s.32-.23.48-.34-.2-.26-.3-.39a4.69 4.69 0 0 1-.31-.48c-.09-.13 0-.32 0-.48s-.3-.3-.39-.39-.39 0-.56 0h-.56a3.16 3.16 0 0 0-.56.09c-.12 0-.46-.2-.61-.26a2.59 2.59 0 0 0-.61.31l-.47.26c-.27.15-.28 0-.43 0s-.31-.21-.43-.3-.29 0-.43 0a2.1 2.1 0 0 0-.52.13 1.79 1.79 0 0 0-.47.22c-.16.07-.18.32-.26.48a4 4 0 0 1-.52.09c-.19 0-.1.16-.22.35s.24.37.26.39c.2.3 0 .23 0 .43s-.31.1-.43.13a4.45 4.45 0 0 0-.43.17c-.19.08-.08.33-.13.52a4 4 0 0 0 0 .52c0 .21.32.08.48.13a2.28 2.28 0 0 0 .56 0c.19 0 .5.08.56.09a3 3 0 0 1 .56.17c.28.09.29.17.52.31s.16.23.31.43a1.16 1.16 0 0 1 .13.43c.07.24-.25.1-.35.13s-.42-.2-.56-.26-.15-.29-.22-.43c-.17-.34-.17 0-.22 0s0 .53 0 .61-.05.35-.09.56-.08.36-.13.56l-.13.52a6 6 0 0 0-.09.61 1.5 1.5 0 0 0 .13.52c.07.27.09.29.13.43s0 .2 0 .43-.33.28-.35.3l-.39.39a1.87 1.87 0 0 0-.26.48 1.32 1.32 0 0 0-.13.48c-.05.19-.09.37-.13.56s-.07.47-.09.61a1.48 1.48 0 0 1-.22.47c-.14.3 0 .1-.09.39s0 .18 0 .43-.11.06-.3.17-.31-.06-.48-.09-.35-.12-.52-.17a1.67 1.67 0 0 0-.52 0 3.74 3.74 0 0 0-.52 0c-.39 0 0 .22 0 .34s.2.2.31.31-.12.33-.17.48a3.41 3.41 0 0 1-.31.52c-.1.17 0 .25 0 .47s.28.22.39.31.43 0 .56 0a2.07 2.07 0 0 0 .47-.26c.23-.12.33.33.35.35s0 .11 0 .17v.09c0 .09.06.22.13.43a2.3 2.3 0 0 0 .22.43c.08.16.34.18.47.26v.16l-.07.52c0 .16 0 .34-.07.48a1.82 1.82 0 0 1-.17.45c-.05.14-.28.18-.38.24s-.23 0-.38 0-.28.17-.41.24-.2.23-.31.34a2.38 2.38 0 0 0-.51.1 3.5 3.5 0 0 1-.31.38c-.08.1-.35.11-.45.14s-.14.08-.31.17.29.32.31.34.17.21.24.31 0 .29 0 .41a2 2 0 0 1-.14.41 1.78 1.78 0 0 1-.28.41l-.17.28c-.08.13-.37.06-.45.07a3.19 3.19 0 0 1-.34-.28c-.19-.15-.31.07-.45.1s-.27.3-.31.34-.26.07-.41.1-.25-.07-.38-.1-.16.35-.17.38a1.3 1.3 0 0 1-.24.34c-.08.11-.39-.15-.45-.17s-.22-.3-.28-.38-.19-.13-.34-.24a2.07 2.07 0 0 0-.45-.17c-.22-.09-.17.22-.24.31l-.24.28c-.13.14-.36 0-.52 0h-.38c-.19 0-.24.08-.41.14s0 .41 0 .45.23.28.28.34.17.25.24.34a2.09 2.09 0 0 0 .28.28c.12.12.1.32.14.45s-.06.27-.1.45-.07.36-.1.55.1.28.14.38.19.21.31.34.27.09.41.14.13.14.28.31-.13.38-.14.41-.13.3-.21.48 0 .14 0 .34v.41c0 .22-.13.19-.21.31a2.69 2.69 0 0 1-.24.28c-.1.12-.22.22-.31.31a3.77 3.77 0 0 0-.24.31l-.24.31c-.19.24.11.29.14.34s.23 0 .34.07.14.26.21.38 0 .2 0 .38-.17.34-.21.41a1.8 1.8 0 0 1-.28.34c-.11.13-.29 0-.45 0H.2c-.23 0-.16.25-.24.38s.14.36.17.45a2.65 2.65 0 0 0 .31.45 1.17 1.17 0 0 1 .1.48l.1.48c.06.27-.09.18-.17.34s-.16.14-.24.21 0 .37 0 .48a1.55 1.55 0 0 0 .14.45c0 .14.19.12.28.17s.13.28.17.38a2.63 2.63 0 0 1 .07.45c0 .21.06.29.1.48s.2.11.31.17l.34.21c.07 0 0 .47 0 .52s-.23.2-.28.24-.06.26-.1.41a1.73 1.73 0 0 0 .1.41c.08.3.17.14.24.21s.4-.09.45-.1c.2 0 .27.12.38.17s0 .32.07.45a1.33 1.33 0 0 1-.1.41 1.71 1.71 0 0 0 0 .38c0 .14.12.24.17.34a2.61 2.61 0 0 0 .24.34.55.55 0 0 0 .14.16h-.07c-.24-.05-.06 0-.28.1s-.16.25-.24.38-.25 0-.38-.07 0 0-.17.07-.09.14-.21.31-.12.22-.17.31-.21.16-.31.24-.12.25-.21.45-.15.19-.28.34-.28.19-.31.21.13.39.14.41-.11.3-.14.38-.09.3-.14.48a.75.75 0 0 0 0 .41 1.37 1.37 0 0 0 .14.41c0 .1.18.11.28.17s.11.1.28.24 0 .23 0 .34.28.26.34.31.12.2.21.34.14.21.21.31.29.15.41.21a2.08 2.08 0 0 0 .52.07c.06 0 .18.33.21.38a1.46 1.46 0 0 1 0 .52V68c0 .12-.17.28-.21.34a2.46 2.46 0 0 1-.31.34 1.52 1.52 0 0 0-.21.34c-.07.11 0 .29.07.41a1.1 1.1 0 0 0 .1.31c0 .07.31.13.41.17l.12.05c-.18 0-.37-.06-.58-.11s-.25.09-.54.19-.13.29-.29.63c-.08.18.37.33.44.39s.66 0 .73 0c.33 0 .34.22.53.34s0 .61 0 .68a5.75 5.75 0 0 0 .05.63c0 .18.26.3.39.44s.29.39.44.58a3.21 3.21 0 0 1 .29.68l.24.54c.15.34.42 0 .54 0s.32-.49.39-.58c.21-.32.24 0 .49 0a3.62 3.62 0 0 1 .29.63 5.78 5.78 0 0 1 .2.63c.1.32.3 0 .39-.05s.2-.29.29-.43.29.29.44.43.31.14.53.25a1.18 1.18 0 0 0 .76 0c.23-.08.23-.31.31-.43s-.21-.58-.24-.73 0 0 0-.15a.37.37 0 0 0 0 .06v.06a.81.81 0 0 0 .18.43l.06.07c.05.08.11.14.16.15l.1.08a1.3 1.3 0 0 0 .41.14c.16.05.12.21.21.34a2.71 2.71 0 0 1 .14.38 1.85 1.85 0 0 0 .24.38c.07.12.21.15.34.24a1.51 1.51 0 0 0 .41.17 3.57 3.57 0 0 0 .34.1 2 2 0 0 0 .48 0 4.47 4.47 0 0 1 .52.07c.05 0 .33-.24.38-.28a1.1 1.1 0 0 1 .48-.14c.21-.06.25.09.38.14a1.91 1.91 0 0 1 .34.24c.1.07.27.14.38.21l.34.21c.18.11.19 0 .38.07a1.07 1.07 0 0 1 .38.21c.14.08.17.21.28.34a.73.73 0 0 0 .36.22v.11h.16l-.18.25c-.16.23-.19.3-.34.53a2 2 0 0 0-.15.63c0 .11-.07.39-.1.58s-.21.37-.34.58-.42.1-.63.15-.32.22-.49.34a2.67 2.67 0 0 0-.44.53 5 5 0 0 1-.53.44c-.16.13-.19.31-.29.49s-.18.35-.29.58a2.57 2.57 0 0 0-.15.68c-.06.27-.17.33-.29.58l-.29.58c-.12.24-.14.34-.24.58 0 0 0 .6-.05.68a2.52 2.52 0 0 1-.34.63 3.09 3.09 0 0 0-.19.49c0 .1-.19.34-.25.44a5.3 5.3 0 0 0-.24.54 2.84 2.84 0 0 0-.15.68 3.82 3.82 0 0 0-.05.63v.58a1.56 1.56 0 0 1-.14.58 1.78 1.78 0 0 1-.2.43c0 .11-.38.14-.39.15-.21.08-.09.11-.25.29s0 .62 0 .78a3.58 3.58 0 0 0 .15.73c0 .22.12.56.15.68.06.3.28.24.29.25s.51-.14.53-.15a.77.77 0 0 1 .2 0c.25 0 .21.39.29.54a2.45 2.45 0 0 1 .15.63c.1.43.17.07.34.15s.47-.43.53-.49.53.1.54.1l.68.1h.63c.22 0 .33-.33.49-.49s.32-.29.49-.44a2.94 2.94 0 0 1 .49.24c.21.1.25.28.39.44a2.17 2.17 0 0 0 .44.34c.13.1.64 0 .68 0h1.03c.18 0-.1-.35-.15-.53s-.42 0-.63 0-.25-.37-.29-.44.14-.34.19-.49.35-.32.44-.39a2.34 2.34 0 0 0 .34-.49 4.52 4.52 0 0 1 .39-.44c.21-.23.24.07.49.15a4 4 0 0 1 .44.25c.21.12.52 0 .73 0s.34.3.39.34-.26.47-.29.54c-.14.26-.19.22-.34.39s.12.25.15.29.35-.16.53-.25.13-.23.25-.43c.23-.41.19-.05.39-.1s.46.13.68.19.53-.25.63-.29c.27-.12.36 0 .58 0s.36.41.43.49.32.32.44.44c.31.31.14-.14.19-.19s-.28-.36-.34-.44-.31-.21-.49-.34-.35-.22-.53-.34a1.93 1.93 0 0 1-.34-.29c-.38-.32.19-.31.25-.39s.55.34.63.39a2.41 2.41 0 0 1 .49.53 2.87 2.87 0 0 0 .49.34l.54.39c.11.08.26-.07.39-.1s.44.24.54.29a2.16 2.16 0 0 1 .34.29l.63-.09c.14 0 .41.24.49.29s.28.39.39.54.42.25.63.39.51 0 .68 0 .35-.25.49-.34a.71.71 0 0 0 .21-.25h.14c-.06.19-.13.4-.15.43-.18.25 0-.06.14.55.07.28.55.14.83.21s.35.35.55.55a4.5 4.5 0 0 0 .55.41c.14.11 0 .43 0 .76a3.56 3.56 0 0 1 1 .14c.38.07-.06.58-.07.69a6.38 6.38 0 0 0 0 .76c0 .18.37 0 .55 0 0 0 .4-.58.48-.69a5 5 0 0 1 .69-.69l.14-.14-.28-.28c-.28-.28-.13-.41-.28-.89-.06-.19.26-.63.34-.83a7.08 7.08 0 0 1 .48-.83c.12-.2.28.37.41.55a2.86 2.86 0 0 1 .28.69c.1.25.5-.18.76-.28s.23 0 .34.07.74-.06.83-.07c.27 0 .46.28.69.41l.62.28c.26.11.09.55.14.83s.46.46.62.62.46-.17.76-.28c.63-.23.22 0 .69.07.31 0 .42-.17.69-.28a3.82 3.82 0 0 0 .76-.48 3.56 3.56 0 0 1 .89-.34 2.71 2.71 0 0 1 1.09-.05c.23-.17.67-.43.91-.64 0 0 .39-.5.62-.55s.72-.18 1-.21.19-.13.69-.07a5.61 5.61 0 0 0 1.1.14c.28 0 .75.1.89-.14s.21-.55.41-.69.62-1 .89-.62.07.47.48.62a4.26 4.26 0 0 1 .76.28c.09.05.38.72.76.41s.45-.72.76-.62.41.26.62.21.69-.46.76-.21.24 0 .14.55c0 .23-.35.6-.14.69 0 0 .57.08.69.28s.19.54.41.69.29.74.62.41.46-.18.48-.48.05-.68.07-.89.17-.9.07-1a5.1 5.1 0 0 1-.69-.41c0-.07-.76-.29-.48-.69a5.62 5.62 0 0 0 .48-.69c.06-.23.53-.79.28-1.1s-.08-.67-.62-.76a4.13 4.13 0 0 1-.83-.14 3.12 3.12 0 0 0-.28-.74c-.16-.23-.59-.43-.48-.69.18-.44.07-.48.34-.83 0 0 .44-.6.48-.62.28-.14.23-.31.55-.28s.49.21.55.07c.13-.29.09-.55.34-.76s.41-.51.69-.55.65 0 .89-.14.52-.15.76-.48.31-.4.48-.69.34-.19.41-.69a3.55 3.55 0 0 1 .14-.89c.09-.15.17-.69.41-.69h.69c.08 0 .83 0 .89-.21s.34-.4.28-.83-.07-.6-.14-.89-.12-.58-.21-.89c-.14-.51.3-.56-.21-.76-.34-.13-.63-.21-.89-.34s-.59-.28-.83-.41-.75-.2-.83-.48 0-.67-.28-1-.14-.57-.55-.69-.74 0-1-.28-.48-.32-.62-.62a3 3 0 0 0-.34-.76c-.21-.25-.34-.45-.62-.76-.13-.14-.41-.78-.69-.76a3.16 3.16 0 0 1-.83.07c-.21-.14-.67-.26-.83-.55s-.19-.37-.41-.76-.3-.55-.48-.83a3.89 3.89 0 0 1-.48-.76 3.5 3.5 0 0 0-.28-.83 6.94 6.94 0 0 1-.55-.89c-.07-.17-.48-.79-.41-1s.14-.47.28-.76c0-.08.47-.79.41-.89s-.2-.39-.34-.62a3.05 3.05 0 0 0-.48-.76c-.3-.3-.44-.41-.69-.69s-.51-.52-.69-.76-.48-.4-.48-.62c0 0 .11-.59 0-.76a2.49 2.49 0 0 0-.48-.76l-.03.09v-.21a1.94 1.94 0 0 1 .53.54c.2.4.48.09.76.14l.76.14c.26 0 .56-.51.76-.69s.38-.38.55-.55a8.75 8.75 0 0 1 .76-.62 5.72 5.72 0 0 1 .76-.48c.41-.26.55-.08 1-.14a2.66 2.66 0 0 1 .83.14c.49.08.51-.28.76-.41s.45-.35.62-.48.41-.37.69-.62.39-.39.55-.55.44-.22.69-.34.47-.21.76-.34l.69-.21c.25-.07.23-.46.34-.69s.78-.17 1-.21a5.34 5.34 0 0 0 .75-.42c.18-.07.64-.16.83-.21.43-.11.29-.23.62-.48a6.56 6.56 0 0 1 .62-.41 4.84 4.84 0 0 1 1 0c.2 0 .61-.55.69-.62s.62-.39.76-.48c.32-.2 0-.47 0-.69s-.28-.5-.41-.76.6-.18.89-.28.61.15.83.21c.47.12.29.16.62.34s0 .6.07.89c0 .13.59.15.83.21s-.21.59-.28.76.59.49.76.62c.35.29.54-.16.69-.21s.33-.66.41-.83a4.86 4.86 0 0 0 .28-1c.07-.25.15-.6.21-.83a3.3 3.3 0 0 0 0-.89v-1a3.24 3.24 0 0 1 .28-.83c.11-.34-.15-.73-.21-1a4.57 4.57 0 0 0-.41-.76c-.15-.27.23-.45.34-.69 0-.41-.35-.66-.62-1.1-.09-.11-.82-.13-.89-.14a6.29 6.29 0 0 1-.64-.14v-.32c.26 0 .13-.1.3-.15a5.8 5.8 0 0 0 .14-.83c0-.28-.47-.42-.62-.55s-.09-.24-.21-.55-.34-.42-.55-.69-.05-.42-.07-.55a4.19 4.19 0 0 1 .41-.69 2.5 2.5 0 0 0 .14-1 7.34 7.34 0 0 1 .28-.83 4.21 4.21 0 0 0-.14-1c0-.12 0-.66.07-1a3 3 0 0 0-.07-.83c0-.09-.73-.4-.76-.41s-.27-.59-.34-.76a3.66 3.66 0 0 1-.21-1c0-.21.34-.52.41-.62.18-.27.09-.65.14-1s-.44-.61-.55-.76a3.8 3.8 0 0 0-.69-.62 3.59 3.59 0 0 1-.55-.76c-.18-.24-.62-.33-.89-.48a5.48 5.48 0 0 1-.83-.69 2.42 2.42 0 0 0-.62-.34c-.45-.25 0-.41 0-.83 0-.22.58-.58.69-.69.32-.32.3-.6.48-1a8.44 8.44 0 0 1 .48-.76 4.42 4.42 0 0 0 .34-.89 2.82 2.82 0 0 1 .48-.83 8.37 8.37 0 0 0-.34-1c-.18-.51-.23-.26-.43-.3 0-.08.1-.31.21-.62s-.28-.68-.34-.83a3.23 3.23 0 0 1-.07-1 4.18 4.18 0 0 0-.28-.76 4 4 0 0 1-.14-.83v-.06a2.43 2.43 0 0 1-.13-.29c.23-.59-.41-.45-.62-.69s-.71.24-.83.28-.44-.57-.48-.62c-.22-.28-.54-.12-.89-.21s-.25-.46-.41-.76-.24-.48-.34-.69a2 2 0 0 1-.07-.69l-.55-.83c-.06-.09.27-.82.33-1 .16-.34-.32-.4-.47-.56s-.68.21-.84.21a5.84 5.84 0 0 1-.69-.14c-.26-.05-.32.41-.48.62s-.37-.46-.55-.69-.55-.14-.83-.21c-.09 0-.59-.32-.76-.41s-.53-.24-.76-.34c-.39-.18-.06-.4-.07-.48a2.88 2.88 0 0 1 .07-.62 3.13 3.13 0 0 0-.28-.83c-.08-.24-.32.23-.48.34s-.32-.09-.48-.14-.41.32-.62.48-.74-.31-.83-.34-.46.08-.76.14-.23.31-.41.55a2.37 2.37 0 0 0-.28.76 2 2 0 0 1-.34.55c-.13.2-.23-.41-.34-.62s.36-.73.41-.83.51-.46.69-.62.6-.18.89-.28.67-.14 1-.21a5.58 5.58 0 0 0 .89-.34h-.83a8.06 8.06 0 0 0-1 .14c-.4.06-.55-.23-.83-.34-.48-.2-.31 0-.69.07s-.46.4-.62.55-.15.68-.21 1a5.07 5.07 0 0 1-.62.62l-.55.55a7.12 7.12 0 0 0-.62.76c-.19.23 0 .6 0 .89s-.46 0-.69 0c0 0-.33-.72-.34-.76-.12-.27-.37.46-.55.69s-.45.09-.69.14a3 3 0 0 1-.83-.07 2.15 2.15 0 0 0-.62.14c-.41.09-.45.28-.76.48-.15.1.23.28.34.41.33.39-.05.33-.14.83a7.06 7.06 0 0 1-.28.76c-.17.47-.28.36-.48.62s-.28-.23-.41-.34-.41-.48-.41-.48-.64.29-.76.34c-.3.14-.09 0-.21 0-.42 0-.16-.07-.48-.21s0-.55 0-.83c0-.58-.63.06-.76.07s-.5.69-.55.76a5.23 5.23 0 0 1-.76.62 8.42 8.42 0 0 0-.69.69c-.44.44-.11.29-.2.6l-.28-.46a1.51 1.51 0 0 0-.21-.28c-.1-.14.14-.32.21-.48.18-.43.23-.29.48-.62s.31-.36.48-.55-.2-.49-.28-.69-.38-.22-.48-.28c-.26-.15.09-.6.14-.89.1-.67.32.11.41.14.64.21.15 0 .62-.07.29 0 .36-.57.48-.76a7.23 7.23 0 0 1 .55-.69 3.74 3.74 0 0 0 .34-.69c.06-.13-.12-.72-.14-.83-.08-.47-.21-.41-.34-.69s-.76 0-.83 0c-.35 0-.35.5-.48.69s-.66.27-.83.34-.3-.11-.55-.21a7.87 7.87 0 0 1-.76-.41c-.4-.22-.29-.29-.62-.62s-.55-.23-.83-.34c-.49-.2-.25.38-.41.62a3.15 3.15 0 0 1-.55.55c-.08.08-.23 0-.34.07-.3.06.09-.6.14-.89s-.44-.44-.55-.55-.56 0-.83 0a8.51 8.51 0 0 0-1 .14c-.27 0 .41-.37.62-.55s0-.39 0-.62v-.85c0-.42-.31-.18-.34-.21-.22-.13-.23.46-.34.69s-.46.14-.69.21-.37 0-.55-.07h-.07c-.25 0 0 0 .34-.14s.49-.49.69-.69a4.7 4.7 0 0 1 .62-.48l.48-.34c.18-.27 0-.64.07-1s-.12-.39-.21-.69-.62-.26-.83-.34a2.65 2.65 0 0 0-1 0c-.36 0-.43-.34-.69-.55s-.3 0-.69 0-.37.53-.48.69c-.34.48-.19.11-.48.28a4.46 4.46 0 0 1-.83-.48 10 10 0 0 0-1-.41c-.29-.13-.51-.26-.83-.41s-.52 0-.69 0-.23.32-.34.48a7.21 7.21 0 0 1-.76-.48 3.62 3.62 0 0 0-.89-.21zm42 15.65c.14.26-.15-.8-.02-.01zM22 5.49c-.16 0-.55.4-.76.5s.5.28.76.41 0-.55.07-.83c-.08-.05-.09-.08-.12-.09zm-1.45.31c-.08 0-.16.59-.24.81s.08.41.14.69.41 0 .62 0 .32-.18.48-.28c.29.16-.5-.41-.76-.62s-.14-.37-.21-.55c-.06-.03-.07-.05-.08-.05zm37.5.25c-.21 0-.44.08-.51.07-.48-.07-.43.34-.62.48a2.53 2.53 0 0 0-.34.41c-.43.51.1.26.14.34s.46.14.69.21a1.08 1.08 0 0 1 .4.28c-.13 0-.37.36-.54.47s-.37-.14-.55-.21-.44.38-.55.48.31.62.34.69l.27.73c.15.29-.39.39-.48.48s.14.55.21.83c.14.58.17.2.48.55 0 0 .8.25.89.28.67.21.31-.24.62-.48s.18-.5.28-.76c.68-.46.77-.41 1.17-.07.24.1-.09.5-.14.76s.68.15.8-.08a6.1 6.1 0 0 1 .44-.47c.06-.07-.24-.66-.28-.76s-.53-.47-.62-.55a2.66 2.66 0 0 1-.46-.73c-.28-.4.32-.65.41-.83.23-.47-.36-.51-.48-.69a5.71 5.71 0 0 0-.76-.14c-.5-.09-.31-.23-.55-.41s0-.46.07-.69-.17-.24-.38-.19zM22.78 7.72c-.19.05-.38.56-.42.6-.25.25.13.22.28.48s.5-.32.76-.48c.24 0-.32-.37-.48-.55a.14.14 0 0 0-.14-.05zm35.06.21l.06.06c.31.24.21.24.48.55s.11.59.14.76-.28-.46-.41-.69a2.75 2.75 0 0 1-.27-.68zm-33.69.54c-.16 0 .23.47.31.69s.24-.29.37-.55a1.48 1.48 0 0 1-.35-.07h.39c.08-.12-.23 0-.41 0l-.28-.06zm.73.07v.07s.02-.02-.01-.08zm16.14 0c-.17 0-.4.26-.52.31s-.14.55-.21.83c0 .06.59.33.62.34s.38.69.41.76c.12.23.09-.5.14-.76 0-.07.45-.05.7-.07.47-.36-.3-.57-.43-.83s-.4-.36-.62-.55a.13.13 0 0 0-.1-.07zm20.86 4.74c-.16 0-.28.27-.37.31-.29.16-.27 1.35.06 1a2.86 2.86 0 0 1 .28.69c.11.27.26-.41.46-.62s.24.2.48.41-.19.69-.21.76c-.07.25-.5-.14-.76-.21s.13.78.14.83c.05.31.51.36.69.48s.79-.11 1-.14c.64-.09.23-.17.55-.41l.21-.89c.28-.05-.69-.75-.76-.83s-.37-.14-.55-.21-.26-.3-.48-.55-.35-.32-.53-.51a.22.22 0 0 0-.22-.15zm-22.83 6.23a.72.72 0 0 1-.14.86.89.89 0 0 1 .16-.37.64.64 0 0 0-.02-.49zM3.23 60.27zm0 9.84a.56.56 0 0 0 .18.05v.06a.78.78 0 0 1-.17-.11z', fill: '#fff' }),
	          _react2.default.createElement('path', { d: 'M7.07 58.71l1.37 4.11h4.34L9.25 65.4l1.37 4.11-3.55-2.58-3.55 2.58 1.37-4.11-3.55-2.58h4.35l1.37-4.11z', fill: '#deb718' })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _BadgesModule2.default.badgeLocationText },
	        _react2.default.createElement(
	          'h2',
	          { className: _BadgesModule2.default.badgeTitle },
	          _localization2.default[language].locationTitle
	        ),
	        _react2.default.createElement(
	          'span',
	          null,
	          _localization2.default[language].locationText
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: _BadgesModule2.default.badgeLink },
	          _localization2.default[language].locationLink,
	          '  \xBB'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: _localization2.default[language].featuresTarget, className: [_BadgesModule2.default.badge, _BadgesModule2.default.badgeFeatures].join(' ') },
	      _react2.default.createElement(
	        'div',
	        { className: _BadgesModule2.default.badgeFeaturesIcons },
	        _react2.default.createElement(
	          'div',
	          { className: _BadgesModule2.default.badgeFeaturesIcon },
	          _react2.default.createElement(_Icon2.default, { type: 'group', size: 32 }),
	          _react2.default.createElement(
	            'span',
	            null,
	            '20-25'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _BadgesModule2.default.badgeFeaturesIcon },
	          _react2.default.createElement(_Icon2.default, { type: 'bedroom', size: 32 }),
	          _react2.default.createElement(
	            'span',
	            null,
	            '9'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _BadgesModule2.default.badgeFeaturesIcon },
	          _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(_Icon2.default, { type: 'wifi', size: 32 })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _BadgesModule2.default.badgeFeaturesIcon },
	          _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(_Icon2.default, { type: 'nosmoking', size: 32 })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _BadgesModule2.default.badgeFeaturesText },
	        _react2.default.createElement(
	          'h2',
	          { className: _BadgesModule2.default.badgeTitle },
	          _localization2.default[language].featuresTitle
	        ),
	        _localization2.default[language].featuresText,
	        _react2.default.createElement(
	          'span',
	          { className: _BadgesModule2.default.badgeLink },
	          _localization2.default[language].featuresLink,
	          ' \xBB'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'a',
	      {
	        href: _common2.default[language].bookUrl,
	        target: '_blank',
	        rel: 'noopener noreferer',
	        className: [_BadgesModule2.default.badge, _BadgesModule2.default.badgeBook].join(' ')
	      },
	      _react2.default.createElement(
	        'div',
	        { className: _BadgesModule2.default.badgeBookTop },
	        _react2.default.createElement(
	          'div',
	          { className: _BadgesModule2.default.badgeBookIcon },
	          _react2.default.createElement(_Icon2.default, { type: 'calendar', size: 40 })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _BadgesModule2.default.badgeBookTitle },
	          _react2.default.createElement(
	            'h2',
	            { className: _BadgesModule2.default.badgeTitle },
	            _localization2.default[language].bookTitle
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _BadgesModule2.default.badgeBookText },
	        _react2.default.createElement(
	          'span',
	          { className: _BadgesModule2.default.badgeLink },
	          _localization2.default[language].bookLink,
	          ' \xBB'
	        )
	      )
	    )
	  );
	};
	
	Badges.propTypes = {
	  language: _propTypes2.default.string.isRequired
	};
	
	exports.default = Badges;
	module.exports = exports['default'];

/***/ }),

/***/ 302:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"loader":"src-components-PageHome-Badges----Badges-module---loader---2v5kO","before":"src-components-PageHome-Badges----Badges-module---before---2mko6","after":"src-components-PageHome-Badges----Badges-module---after---1c06G","t-body":"src-components-PageHome-Badges----Badges-module---t-body---1s864","t-small":"src-components-PageHome-Badges----Badges-module---t-small---1w1Pv","badgeLocationText":"src-components-PageHome-Badges----Badges-module---badgeLocationText---2orzU","badgeFeaturesText":"src-components-PageHome-Badges----Badges-module---badgeFeaturesText---kapn0","t-heading-xs":"src-components-PageHome-Badges----Badges-module---t-heading-xs---y9S4c","badgeTitle":"src-components-PageHome-Badges----Badges-module---badgeTitle---HRm-o","t-heading-s":"src-components-PageHome-Badges----Badges-module---t-heading-s---3WiAa","t-heading-m":"src-components-PageHome-Badges----Badges-module---t-heading-m---32lEV","t-heading-l":"src-components-PageHome-Badges----Badges-module---t-heading-l---fJ5MH","t-heading-xl":"src-components-PageHome-Badges----Badges-module---t-heading-xl---3B_q8","t-anchors":"src-components-PageHome-Badges----Badges-module---t-anchors---2rwnr","t-buttons":"src-components-PageHome-Badges----Badges-module---t-buttons---2gD1k","t-buttons-large":"src-components-PageHome-Badges----Badges-module---t-buttons-large---1K4os","t-formLabel":"src-components-PageHome-Badges----Badges-module---t-formLabel---3h4oH","t-formHelper":"src-components-PageHome-Badges----Badges-module---t-formHelper---ggEEX","t-formInput":"src-components-PageHome-Badges----Badges-module---t-formInput---aLGmR","t-tableHeading":"src-components-PageHome-Badges----Badges-module---t-tableHeading---KQJNz","t-tableBody":"src-components-PageHome-Badges----Badges-module---t-tableBody---1ermj","t-opaque":"src-components-PageHome-Badges----Badges-module---t-opaque---2vHod","t-bold":"src-components-PageHome-Badges----Badges-module---t-bold---3XBMV","t-italic":"src-components-PageHome-Badges----Badges-module---t-italic---kKxlb","badges":"src-components-PageHome-Badges----Badges-module---badges---3s1lK","badge":"src-components-PageHome-Badges----Badges-module---badge---1JKJy","slideInBottomMild":"src-components-PageHome-Badges----Badges-module---slideInBottomMild---3j34I","badgeLink":"src-components-PageHome-Badges----Badges-module---badgeLink---1erhE","badgeLocation":"src-components-PageHome-Badges----Badges-module---badgeLocation---1QlBX","badgeLocationMap":"src-components-PageHome-Badges----Badges-module---badgeLocationMap---99rPV","badgeFeatures":"src-components-PageHome-Badges----Badges-module---badgeFeatures---1rkos","badgeFeaturesIcons":"src-components-PageHome-Badges----Badges-module---badgeFeaturesIcons---pSyaA","badgeFeaturesIcon":"src-components-PageHome-Badges----Badges-module---badgeFeaturesIcon---CmlNZ","badgeBook":"src-components-PageHome-Badges----Badges-module---badgeBook---i1vSp","badgeBookTop":"src-components-PageHome-Badges----Badges-module---badgeBookTop---2VwR4","badgeBookIcon":"src-components-PageHome-Badges----Badges-module---badgeBookIcon---1jmgy","badgeBookTitle":"src-components-PageHome-Badges----Badges-module---badgeBookTitle---e8Vwt","badgeBookText":"src-components-PageHome-Badges----Badges-module---badgeBookText---2a3Wm","slideInTop":"src-components-PageHome-Badges----Badges-module---slideInTop---Soh9i","slideInTopMild":"src-components-PageHome-Badges----Badges-module---slideInTopMild---3kf7G","slideInBottom":"src-components-PageHome-Badges----Badges-module---slideInBottom---16Hzo","slideOutTop":"src-components-PageHome-Badges----Badges-module---slideOutTop---2uwPs","slideOutTopMild":"src-components-PageHome-Badges----Badges-module---slideOutTopMild---17mkZ","slideOutBottom":"src-components-PageHome-Badges----Badges-module---slideOutBottom---2sU99","slideOutBottomMild":"src-components-PageHome-Badges----Badges-module---slideOutBottomMild---354w5","shake-horizontal":"src-components-PageHome-Badges----Badges-module---shake-horizontal---1oeom"};

/***/ }),

/***/ 190:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Badges = __webpack_require__(189);
	
	var _Badges2 = _interopRequireDefault(_Badges);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _Badges2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 191:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var localization = {
	  nl: {
	    locationTitle: 'Locatie',
	    locationText: 'Gelegen in Kopp (DE), een dorpje midden in de prachtige Vulkaneifel',
	    locationLink: 'Routebeschrijving',
	    locationTarget: '/omgeving',
	    featuresTitle: 'Kenmerken',
	    featuresText: '9 Slaapkamers met ieder een eigen douche, toilet en wastafel',
	    featuresLink: 'Bekijk alle kenmerken',
	    featuresTarget: '/hethuis',
	    bookTitle: 'Boek online',
	    bookLink: 'Prik uw datums en boek vandaag nog via Micazu'
	  },
	  de: {
	    locationTitle: 'Lage',
	    locationText: 'Das Haus liegt in Kopp, einem Dorf in der Mitte der schönen Vulkaneifel',
	    locationLink: 'Wegbeschreibung',
	    locationTarget: '/dieumgebung',
	    featuresTitle: 'Eigenschaften',
	    featuresText: '9 Slafzimmer mit jeweils eigener Dusche, Toilette und Washbecken',
	    featuresLink: 'Alle Eigenschaften anzeigen',
	    featuresTarget: '/dashaus',
	    bookTitle: 'Online buchen',
	    bookLink: 'Wählen Sie Ihre Daten und buchen Sie noch heute mit Micazu'
	  },
	  en: {
	    locationTitle: 'Location',
	    locationText: 'Located in Kopp (DE), a village in the middle of the beautiful Vulkaneifel',
	    locationLink: 'Directions',
	    locationTarget: '/dieumgebung',
	    featuresTitle: 'Features',
	    featuresText: '9 Bedrooms each with their own shower, toilet and sink',
	    featuresLink: 'View all features',
	    featuresTarget: '/thehouse',
	    bookTitle: 'Book online',
	    bookLink: 'Pick your dates and book today through Micazu'
	  }
	};
	
	exports.default = localization;
	module.exports = exports['default'];

/***/ }),

/***/ 192:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _HeroModule = __webpack_require__(303);
	
	var _HeroModule2 = _interopRequireDefault(_HeroModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var autoLoop = null;
	
	var Hero = function (_Component) {
	  _inherits(Hero, _Component);
	
	  function Hero() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Hero);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      currentImageIndex: 0
	    }, _this.componentDidMount = function () {
	      _this._autoLoop('start');
	    }, _this.componentWillUnmount = function () {
	      _this._autoLoop('stop');
	    }, _this._nextSlide = function () {
	      _this.setState({
	        currentImageIndex: _this.state.currentImageIndex === _this.props.images.length - 1 ? 0 : _this.state.currentImageIndex + 1
	      });
	    }, _this._autoLoop = function (state) {
	      if (state === 'start') {
	        autoLoop = setInterval(function () {
	          _this._nextSlide();
	        }, 12000);
	      } else {
	        clearInterval(autoLoop);
	      }
	
	      return null;
	    }, _this._renderImages = function () {
	      return _this.props.images.map(function (image, index) {
	        return _react2.default.createElement('div', {
	          key: index,
	          className: [_HeroModule2.default.image, _this.state.currentImageIndex === index ? _HeroModule2.default.active : null].join(' '),
	          style: _extends({ backgroundImage: 'url(' + image.image + ')' }, _this.props.slideStyles)
	        });
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Hero.prototype.render = function render() {
	    return _react2.default.createElement(
	      'header',
	      { className: _HeroModule2.default.hero, style: { backgroundColor: this.props.backgroundColor } },
	      _react2.default.createElement(
	        'div',
	        { className: _HeroModule2.default.overlayContent },
	        this.props.overlayContent
	      ),
	      this._renderImages()
	    );
	  };
	
	  return Hero;
	}(_react.Component);
	
	Hero.propTypes = {
	  backgroundColor: _propTypes2.default.string,
	  overlayContent: _propTypes2.default.node,
	  slideStyles: _propTypes2.default.object,
	  images: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    alt: _propTypes2.default.string,
	    image: _propTypes2.default.string.isRequired
	  })).isRequired
	};
	exports.default = Hero;
	module.exports = exports['default'];

/***/ }),

/***/ 303:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"loader":"src-components-PageHome-Hero----Hero-module---loader---22i9R","before":"src-components-PageHome-Hero----Hero-module---before---2MpHe","after":"src-components-PageHome-Hero----Hero-module---after---3CzfS","t-body":"src-components-PageHome-Hero----Hero-module---t-body---237rD","t-small":"src-components-PageHome-Hero----Hero-module---t-small---2pZmP","t-heading-xs":"src-components-PageHome-Hero----Hero-module---t-heading-xs---2KQld","t-heading-s":"src-components-PageHome-Hero----Hero-module---t-heading-s---2KiZk","t-heading-m":"src-components-PageHome-Hero----Hero-module---t-heading-m---20SjR","t-heading-l":"src-components-PageHome-Hero----Hero-module---t-heading-l---SLUu0","t-heading-xl":"src-components-PageHome-Hero----Hero-module---t-heading-xl---2WJte","t-anchors":"src-components-PageHome-Hero----Hero-module---t-anchors---3s_Kg","t-buttons":"src-components-PageHome-Hero----Hero-module---t-buttons---3hjOD","t-buttons-large":"src-components-PageHome-Hero----Hero-module---t-buttons-large---2ZyRJ","t-formLabel":"src-components-PageHome-Hero----Hero-module---t-formLabel---NxKRL","t-formHelper":"src-components-PageHome-Hero----Hero-module---t-formHelper---36Eyy","t-formInput":"src-components-PageHome-Hero----Hero-module---t-formInput---2ekhL","t-tableHeading":"src-components-PageHome-Hero----Hero-module---t-tableHeading---1LeTN","t-tableBody":"src-components-PageHome-Hero----Hero-module---t-tableBody---2gHjK","t-opaque":"src-components-PageHome-Hero----Hero-module---t-opaque---2ktjl","t-bold":"src-components-PageHome-Hero----Hero-module---t-bold---2JL5n","t-italic":"src-components-PageHome-Hero----Hero-module---t-italic---2CO1g","hero":"src-components-PageHome-Hero----Hero-module---hero---3rrvz","slideInBottomMild":"src-components-PageHome-Hero----Hero-module---slideInBottomMild---39LIA","overlayContent":"src-components-PageHome-Hero----Hero-module---overlayContent---27Yn9","image":"src-components-PageHome-Hero----Hero-module---image---Mfs5b","active":"src-components-PageHome-Hero----Hero-module---active---1caJV","panRight":"src-components-PageHome-Hero----Hero-module---panRight---3JnaB","slideInTop":"src-components-PageHome-Hero----Hero-module---slideInTop---1gbWq","slideInTopMild":"src-components-PageHome-Hero----Hero-module---slideInTopMild---3fVzR","slideInBottom":"src-components-PageHome-Hero----Hero-module---slideInBottom---3X9lA","slideOutTop":"src-components-PageHome-Hero----Hero-module---slideOutTop---3NDEU","slideOutTopMild":"src-components-PageHome-Hero----Hero-module---slideOutTopMild---3fzdN","slideOutBottom":"src-components-PageHome-Hero----Hero-module---slideOutBottom---27eXK","slideOutBottomMild":"src-components-PageHome-Hero----Hero-module---slideOutBottomMild---bjtbf","shake-horizontal":"src-components-PageHome-Hero----Hero-module---shake-horizontal---1M2Oz"};

/***/ }),

/***/ 193:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Hero = __webpack_require__(192);
	
	var _Hero2 = _interopRequireDefault(_Hero);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _Hero2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 58:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SliderModule = __webpack_require__(88);
	
	var _SliderModule2 = _interopRequireDefault(_SliderModule);
	
	var _timers = __webpack_require__(97);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var autoLoop = null;
	
	var Slider = function (_Component) {
	  _inherits(Slider, _Component);
	
	  function Slider(props) {
	    _classCallCheck(this, Slider);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.componentDidMount = function () {
	      (0, _timers.setTimeout)(function () {
	        _this.setState({ sliderWidth: _this.sliderElement.offsetWidth });
	      }, 500);
	
	      window.addEventListener('resize', _this._boundWidthListener);
	      _this._autoLoop('start');
	    };
	
	    _this.componentWillUnmount = function () {
	      window.removeEventListener('resize', _this._boundWidthListener);
	      _this._autoLoop('stop');
	    };
	
	    _this._widthListener = function () {
	      _this.setState({ sliderWidth: _this.sliderElement.offsetWidth });
	    };
	
	    _this._previousSlide = function () {
	      var currentImageIndex = _this.state.currentImageIndex;
	      var images = _this.props.images;
	
	
	      _this.setState({
	        currentImageIndex: currentImageIndex === 0 ? images.length - 1 : currentImageIndex - 1
	      });
	    };
	
	    _this._nextSlide = function () {
	      var currentImageIndex = _this.state.currentImageIndex;
	      var images = _this.props.images;
	
	
	      _this.setState({
	        currentImageIndex: currentImageIndex === images.length - 1 ? 0 : currentImageIndex + 1
	      });
	    };
	
	    _this._autoLoop = function (state) {
	      if (state === 'start') {
	        autoLoop = setInterval(function () {
	          _this._nextSlide();
	        }, 8000);
	      } else {
	        clearInterval(autoLoop);
	      }
	
	      return null;
	    };
	
	    _this._renderImages = function () {
	      return _this.props.images.map(function (image, index) {
	        return _react2.default.createElement(
	          'div',
	          {
	            key: index,
	            className: _SliderModule2.default.imageContainer,
	            style: { left: '-' + _this.state.currentImageIndex * _this.state.sliderWidth + 'px' }
	          },
	          _react2.default.createElement('img', { src: image.image, alt: image.alt, className: _SliderModule2.default.imageTag })
	        );
	      });
	    };
	
	    _this.state = {
	      currentImageIndex: 0,
	      sliderWidth: 0
	    };
	
	    _this._boundWidthListener = _this._widthListener.bind(_this);
	    return _this;
	  }
	
	  Slider.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      'div',
	      {
	        className: _SliderModule2.default.slider,
	        ref: function ref(div) {
	          _this2.sliderElement = div;
	        },
	        onMouseEnter: function onMouseEnter() {
	          _this2._autoLoop('stop');
	        },
	        onMouseLeave: function onMouseLeave() {
	          _this2._autoLoop('start');
	        }
	      },
	      _react2.default.createElement(
	        'div',
	        { className: _SliderModule2.default.controls },
	        _react2.default.createElement(
	          'button',
	          { className: _SliderModule2.default.controlLeft, onClick: function onClick() {
	              _this2._previousSlide();
	            } },
	          '\u2039'
	        ),
	        _react2.default.createElement(
	          'button',
	          { className: _SliderModule2.default.controlRight, onClick: function onClick() {
	              _this2._nextSlide();
	            } },
	          '\u203A'
	        )
	      ),
	      this._renderImages()
	    );
	  };
	
	  return Slider;
	}(_react.Component);
	
	Slider.propTypes = {
	  images: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    alt: _propTypes2.default.string.isRequired,
	    image: _propTypes2.default.string.isRequired
	  })).isRequired
	};
	exports.default = Slider;
	module.exports = exports['default'];

/***/ }),

/***/ 88:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"loader":"src-components-Slider----Slider-module---loader---36SEb","before":"src-components-Slider----Slider-module---before---2j73U","after":"src-components-Slider----Slider-module---after---3LoSw","t-body":"src-components-Slider----Slider-module---t-body---CGRje","t-small":"src-components-Slider----Slider-module---t-small---2hRiT","t-heading-xs":"src-components-Slider----Slider-module---t-heading-xs---3QkCq","t-heading-s":"src-components-Slider----Slider-module---t-heading-s---2lhX9","t-heading-m":"src-components-Slider----Slider-module---t-heading-m---3l-r_","t-heading-l":"src-components-Slider----Slider-module---t-heading-l---WD4ZX","t-heading-xl":"src-components-Slider----Slider-module---t-heading-xl---1bqxn","t-anchors":"src-components-Slider----Slider-module---t-anchors---1Mv-U","t-buttons":"src-components-Slider----Slider-module---t-buttons---3T0qX","t-buttons-large":"src-components-Slider----Slider-module---t-buttons-large---2Ne5i","t-formLabel":"src-components-Slider----Slider-module---t-formLabel---1T0kY","t-formHelper":"src-components-Slider----Slider-module---t-formHelper---16SWJ","t-formInput":"src-components-Slider----Slider-module---t-formInput---LZPvm","t-tableHeading":"src-components-Slider----Slider-module---t-tableHeading---2Cxmq","t-tableBody":"src-components-Slider----Slider-module---t-tableBody---3U-PS","t-opaque":"src-components-Slider----Slider-module---t-opaque---32n3Y","t-bold":"src-components-Slider----Slider-module---t-bold---3q8Q-","t-italic":"src-components-Slider----Slider-module---t-italic---1v0EE","slider":"src-components-Slider----Slider-module---slider---3yXx9","controlLeft":"src-components-Slider----Slider-module---controlLeft---3K_Jj","controlRight":"src-components-Slider----Slider-module---controlRight---wVtos","controls":"src-components-Slider----Slider-module---controls---xbtvv","imageContainer":"src-components-Slider----Slider-module---imageContainer---2QzF7","imageTag":"src-components-Slider----Slider-module---imageTag---3QwH6","slideInTop":"src-components-Slider----Slider-module---slideInTop---8gpSH","slideInTopMild":"src-components-Slider----Slider-module---slideInTopMild---3Crc3","slideInBottom":"src-components-Slider----Slider-module---slideInBottom---2UL1Q","slideInBottomMild":"src-components-Slider----Slider-module---slideInBottomMild---1pVie","slideOutTop":"src-components-Slider----Slider-module---slideOutTop---3G-i_","slideOutTopMild":"src-components-Slider----Slider-module---slideOutTopMild---3_vmq","slideOutBottom":"src-components-Slider----Slider-module---slideOutBottom---1VOki","slideOutBottomMild":"src-components-Slider----Slider-module---slideOutBottomMild---2S1AM","shake-horizontal":"src-components-Slider----Slider-module---shake-horizontal---226-5"};

/***/ }),

/***/ 59:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Slider = __webpack_require__(58);
	
	var _Slider2 = _interopRequireDefault(_Slider);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _Slider2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 28:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var commonlocalization = {
	  nl: {
	    bookUrl: 'https://www.micazu.nl/vakantiehuis/duitsland/eifel/kopp/ferienhaus-vulkaneifel-kopp-22798/#availability-prices',
	    contactInfoTitle: 'Contactinformatie',
	    contactFormTitle: 'Contactformulier',
	    germany: 'Duitsland',
	    metaDescription: 'Vakantiehuis in Kopp, Duitsland voor grote gezelschappen tot 25 personen.',
	    metaKeywords: 'vakantiehuis, huren, kopp, duitsland, grote, gezelschappen, personen, ardennen, dolomieten, wandelen, fietsen, mountainiken, wielrennen, motorrijden, kajakken, kayakken, kano, kanoën, kanoen'
	  },
	  de: {
	    bookUrl: 'https://www.micazu.de/ferienwohnung/deutschland/eifel/kopp/ferienhaus-vulkaneifel-kopp-22798/#availability-prices',
	    contactInfoTitle: 'Kontaktinformationen',
	    contactFormTitle: 'Kontaktformular',
	    germany: 'Deutschland',
	    metaDescription: 'Ferienhaus in Kopp, Deutschland für große Gruppen bis zu 25 Personen.',
	    metaKeywords: 'ferienhaus, mieten, hütten, deutschland, große, gruppen, menschen, ardennen, dolomiten, wandern, radfahren, mountainbiken, renradfahren, motorradfahren, kajak, kajakfahren, kanu, kanufahren'
	  },
	  en: {
	    bookUrl: 'https://www.micazu.com/vacation-rentals/germany/eifel/kopp/ferienhaus-vulkaneifel-kopp-22798/#availability-prices',
	    contactInfoTitle: 'Contact information',
	    contactFormTitle: 'Get in touch',
	    germany: 'Germany',
	    metaDescription: 'Holiday home in Kopp, Germany for large groups up to 25 people.',
	    metaKeywords: 'holiday home, rent, kopp, germany, large, groups, people, ardennes, dolomites, hiking, cycling, mountain biking, bicycle racing, motorcycling, kayaking, kayak, canoeing, canoe'
	  }
	};
	
	exports.default = commonlocalization;
	module.exports = exports['default'];

/***/ }),

/***/ 198:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var localization = {
	  nl: {
	    introductionTitle: 'Uw avontuur in de Vulkaaneifel begint hier',
	    introductionP1: 'De wandelingen beginnen letterlijk aan de voordeur. Het vakantiehuis is gelegen in het rustige dorp Kopp, ongeveer 11 km ten zuidwesten van het kuuroord Gerolstein en 17 km ten zuidoosten van Prüm.',
	    introductionP2: 'Het huis is jaren in het bezit geweest van een wandelvereniging, dat is natuurlijk niet zomaar. In de prachtige omgeving (de Vulkaaneifel heeft de titel UNESCO Global Geopark) kan men vele mooie wandelingen maken maar natuurlijk ook fietsen, motorrijden en in de winter zelfs langlaufen.',
	    introductionButton: 'Meer over het huis',
	    introductionButtonTarget: '/hethuis',
	    introductionSlider1Alt: 'Het huis',
	    introductionSlider2Alt: 'Eetruimte',
	    introductionSlider3Alt: 'Terras met veranda',
	    introductionSlider4Alt: 'Trampoline',
	    introductionSlider5Alt: 'Natuur zomer',
	    introductionSlider6Alt: 'Natuur winter',
	    reviewsTitle: 'Verslagen en recenties',
	    reviewsP1: '"Jaarlijks organiseren we een familieweek. Tijdens deze week verblijven we op een camping in het Zuiden van het land en maken we veel wandeltochten, fietstochten en dagtripjes naar lokale bezienswaardigheden."',
	    reviewsP2: '"Het zat er al een tijdje aan te komen, een van mijn kinderen vroeg: "Gaan we dit jaar alweer naar diezelfde camping?". Dit jaar zijn we met de hele familie dus maar wat verder doorgereden en hebben we hier geen moment spijt van gehad!"',
	    reviewsButton: 'Lees meer ervaringen op Micazu',
	    reviewsButtonTarget: 'https://www.micazu.nl/over-de-verhuurder/62981/?houseId=25188'
	  },
	  de: {
	    introductionTitle: 'Ihr Abenteuer in der Vulkaneifel beginnt hier',
	    introductionP1: 'Die Wanderungen beginnen buchstäblich vor der Haustür des “Ferienhaus Vulkaneifel Kopp”. Das Haus befindet sich im ruhigen Ortschaft Kopp, ca. 11 km südwestlich von der Kurstadt Gerolstein und 17 km südöstlich von Prüm.',
	    introductionP2: 'Das Haus wurde 1984 erbaut und war seit Jahren im Besitz eines Wandervereins. Das ist logisch. In der schönen Umgebung (die Vulkaneifel hat den Titel UNESCO Global Geopark) kann man viele schöne Wanderungen machen und natürlich auch Radfahren, Motorradfahren und sogar Langlaufen im Winter.',
	    introductionButton: 'Mehr über das Haus',
	    introductionButtonTarget: '/dashaus',
	    introductionSlider1Alt: 'Das Haus',
	    introductionSlider2Alt: 'Esszimmer',
	    introductionSlider3Alt: 'Terrase mit Veranda',
	    introductionSlider4Alt: 'Trampolin',
	    introductionSlider5Alt: 'Natur im Sommer',
	    introductionSlider6Alt: 'Natur im Winter',
	    reviewsTitle: 'Erfahrungen und Bewertungen',
	    reviewsP1: '"Jedes Jahr organisieren wir eine Familienwoche. Während dieser Woche bleiben wir auf einem Campingplatz im Süden des Landes und machen viele Wanderungen, Fahrradtouren und Tagesausflüge zu lokalen Sehenswürdigkeiten."',
	    reviewsP2: '"Letstes Jahr fragte eines meiner Kinder: "Gehen wir wieder zu diesem langweiligen Campingplatz?". So nahmen wir dieses Jahr die ganze Familie mit zur Vulkaneifel und bereuten es nicht für einen Moment!"',
	    reviewsButton: 'Lesen Sie mehr Erfahrungen auf Micazu',
	    reviewsButtonTarget: 'https://www.micazu.de/ihr-gastgeber/62981/?houseId=25188'
	  },
	  en: {
	    introductionTitle: 'Your adventure in the Vulkaneifel starts here',
	    introductionP1: 'The hiking trails literally start at the front door. This holiday home is located in the quiet village of Kopp, about 11 km southwest of the spa town of Gerolstein and 17 km to the southeast of Prüm.',
	    introductionP2: 'The house has previously been in the possession of a hiking club for many years and this is no coincidence. You can make many walks in the beautiful surroundings (the Vulkaneifel has been awarded the UNESCO Global Geopark title) but also cycle, motorcycle and in the winter even cross-country ski.',
	    introductionButton: 'More about the house',
	    introductionButtonTarget: '/thehouse',
	    introductionSlider1Alt: 'The house',
	    introductionSlider2Alt: 'Dining room',
	    introductionSlider3Alt: 'Terrace with veranda',
	    introductionSlider4Alt: 'Trampoline',
	    introductionSlider5Alt: 'Nature in summer',
	    introductionSlider6Alt: 'Nature in winter',
	    reviewsTitle: 'Reviews and experiences',
	    reviewsP1: '"Every year we organize a family week. During this week we stay at a campsite in the South of the country and we make many hiking tours, bike rides and day trips to local attractions."',
	    reviewsP2: '"Last year, one of my children asked: "Are we going to that same boring campsite again?". So this year we took the entire family to the Vulkaneifel and didn\'t regret it for a moment."',
	    reviewsButton: 'Read more experiences on Micazu',
	    reviewsButtonTarget: 'https://www.micazu.com/about-the-host/62981/?houseId=25188'
	  }
	};
	
	exports.default = localization;
	module.exports = exports['default'];

/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Badges = __webpack_require__(190);
	
	var _Badges2 = _interopRequireDefault(_Badges);
	
	var _Hero = __webpack_require__(193);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _ContentBlock = __webpack_require__(10);
	
	var _ContentBlock2 = _interopRequireDefault(_ContentBlock);
	
	var _Button = __webpack_require__(26);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Slider = __webpack_require__(59);
	
	var _Slider2 = _interopRequireDefault(_Slider);
	
	var _home = __webpack_require__(198);
	
	var _home2 = _interopRequireDefault(_home);
	
	var _logo = __webpack_require__(412);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _hero = __webpack_require__(400);
	
	var _hero2 = _interopRequireDefault(_hero);
	
	var _hero3 = __webpack_require__(401);
	
	var _hero4 = _interopRequireDefault(_hero3);
	
	var _hero5 = __webpack_require__(402);
	
	var _hero6 = _interopRequireDefault(_hero5);
	
	var _introductionSlider = __webpack_require__(403);
	
	var _introductionSlider2 = _interopRequireDefault(_introductionSlider);
	
	var _introductionSlider3 = __webpack_require__(404);
	
	var _introductionSlider4 = _interopRequireDefault(_introductionSlider3);
	
	var _introductionSlider5 = __webpack_require__(405);
	
	var _introductionSlider6 = _interopRequireDefault(_introductionSlider5);
	
	var _introductionSlider7 = __webpack_require__(406);
	
	var _introductionSlider8 = _interopRequireDefault(_introductionSlider7);
	
	var _introductionSlider9 = __webpack_require__(407);
	
	var _introductionSlider10 = _interopRequireDefault(_introductionSlider9);
	
	var _introductionSlider11 = __webpack_require__(408);
	
	var _introductionSlider12 = _interopRequireDefault(_introductionSlider11);
	
	var _reviewsImage = __webpack_require__(409);
	
	var _reviewsImage2 = _interopRequireDefault(_reviewsImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage(props) {
	  var language = props.language;
	
	
	  var sliderImages = [{ image: _hero2.default }, { image: _hero4.default }, { image: _hero6.default }];
	
	  var introductionSliderImages = [{ image: _introductionSlider2.default, alt: _home2.default[language].introductionSlider1Alt }, { image: _introductionSlider4.default, alt: _home2.default[language].introductionSlider2Alt }, { image: _introductionSlider6.default, alt: _home2.default[language].introductionSlider3Alt }, { image: _introductionSlider8.default, alt: _home2.default[language].introductionSlider4Alt }, { image: _introductionSlider10.default, alt: _home2.default[language].introductionSlider5Alt }, { image: _introductionSlider12.default, alt: _home2.default[language].introductionSlider6Alt }];
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(_Hero2.default, {
	      images: sliderImages,
	      backgroundColor: '#FFFFFF',
	      overlayContent: _react2.default.createElement('img', { src: _logo2.default, alt: 'Ferienhaus Vulkaneifel Kopp', width: '280' })
	    }),
	    _react2.default.createElement(_Badges2.default, { language: language }),
	    _react2.default.createElement(
	      _ContentBlock2.default,
	      { split: true, reverse: true, darkBackground: true, sliderRight: true },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h2',
	          { className: 't-heading-s' },
	          _home2.default[language].introductionTitle
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _home2.default[language].introductionP1
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _home2.default[language].introductionP2
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          _Button2.default,
	          { type: 'link', to: _home2.default[language].introductionButtonTarget, size: 'large' },
	          _home2.default[language].introductionButton,
	          ' \xBB'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_Slider2.default, { images: introductionSliderImages })
	      )
	    ),
	    _react2.default.createElement(
	      _ContentBlock2.default,
	      { split: true },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h2',
	          { className: 't-heading-s' },
	          _home2.default[language].reviewsTitle
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _home2.default[language].reviewsP1
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _home2.default[language].reviewsP2
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          _Button2.default,
	          { type: 'anchor', to: _home2.default[language].reviewsButtonTarget, target: '_blank', size: 'large' },
	          _home2.default[language].reviewsButton,
	          ' \xBB'
	        )
	      ),
	      _react2.default.createElement('div', { style: { backgroundImage: 'url(' + _reviewsImage2.default + ')' } })
	    )
	  );
	};
	
	IndexPage.propTypes = {
	  language: _propTypes2.default.string.isRequired
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-a8acc2f80fac88527062.js